export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
    DateTime: string;
    GeoIdentifier: string;
    /** Type definition for JSON representation. */
    JSON: unknown;
    /** A string that cannot be passed as an empty value */
    NonEmptyString: string;
    /** Integers that will have a value greater than 0. */
    PositiveInt: number;
};

export type AbTest = {
    __typename?: 'ABTest';
    id: Scalars['String'];
    name: Scalars['String'];
};

/** Data associated with a query for ONLY ad targeting */
export type AdTargeting = {
    __typename?: 'AdTargeting';
    /** Type of activity (e.g. "listing_search") */
    activity?: Maybe<Scalars['String']>;
    /** Searched area (e.g. "Carshalton Beeches Station") */
    areaName?: Maybe<Scalars['String']>;
    /** The current pages brand (e.g. "Zoopla") */
    brand?: Maybe<Scalars['String']>;
    /** The current pages primary brand (e.g. "Zoopla") */
    brandPrimary?: Maybe<Scalars['String']>;
    /** The country code (e.g. "gb") */
    countryCode?: Maybe<Scalars['String']>;
    /** The currency code (e.g. "GBP") */
    currencyCode?: Maybe<Scalars['String']>;
    /** The current listing category (e.g. "residential", "commercial") */
    listingsCategory?: Maybe<Scalars['String']>;
    /** The secone half of a postcode (e.g the outcode of postcode "E15 2QR" would be "2QR") */
    outcode?: Maybe<Scalars['String']>;
    /** Array of outcodes. Outcodes are the secone half of a postcode (e.g the outcode of postcode "E15 2QR" would be "2QR") */
    outcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The current page (e.g. "/for-sale/results/") */
    page?: Maybe<Scalars['String']>;
    /** The letters prefixing of the first half of a postcode (e.g. post code "E15 2QR" has a postal area of "E") */
    postalArea?: Maybe<Scalars['String']>;
    /** Maximum price filter value */
    priceMax?: Maybe<Scalars['String']>;
    /** Minimum price filter value */
    priceMin?: Maybe<Scalars['String']>;
    /** The current region (e.g. "london") */
    regionName?: Maybe<Scalars['String']>;
    /** The results sort order (e.g. "newest_listings") */
    resultsSort?: Maybe<Scalars['String']>;
    /** Complete searched location (e.g. "Carshalton Beeches Station, London") */
    searchLocation?: Maybe<Scalars['String']>;
    /** Total number of search results */
    searchResultsCount?: Maybe<Scalars['Int']>;
    /** The results type (e.g. "for-sale", "to-rent", "new-homes", "commercial") */
    section?: Maybe<Scalars['String']>;
    /** Total number of search results */
    totalResults?: Maybe<Scalars['Int']>;
    /** Flag highlighting if the number of search result has been limited */
    totalResultsWasLimited?: Maybe<Scalars['Boolean']>;
    /** Full URL of current search */
    url?: Maybe<Scalars['String']>;
    /** The view type (e.g. "list", "map") */
    viewType?: Maybe<Scalars['String']>;
    /** County name (e.g. "London") */
    countyAreaName?: Maybe<Scalars['String']>;
    /** Maximum bedrooms filter value */
    bedsMax?: Maybe<Scalars['String']>;
    /** Minimum bedrooms filter value */
    bedsMin?: Maybe<Scalars['String']>;
    /**
     * Property type (e.g. "houses", "flats", "bungalows", "retirement")
     * Returns "null" if the property type is "property"
     */
    propertyType?: Maybe<Scalars['String']>;
};

export type AdditionalLink = {
    __typename?: 'AdditionalLink';
    href?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
};

/** The address for a Property. */
export type Address = {
    __typename?: 'Address';
    country?: Maybe<Scalars['String']>;
    fullAddress: Scalars['String'];
    latitude?: Maybe<Scalars['Float']>;
    longitude?: Maybe<Scalars['Float']>;
    outcode?: Maybe<Scalars['String']>;
    postcode: Scalars['String'];
    uprn: Scalars['String'];
};

export type AddressPostcodeSuggestion = {
    __typename?: 'AddressPostcodeSuggestion';
    g?: Maybe<Array<Maybe<SuggestedAddresses>>>;
    p?: Maybe<Array<Maybe<PastSuggestedAddresses>>>;
};

/** A list of addresses. Hits newer address service. */
export type AddressSearchApi = {
    __typename?: 'AddressSearchAPI';
    /**
     * A combo of addresses plus the postcode related to the search
     * term used to get them
     * @deprecated Please use [Address] instead of this field
     */
    addressesByPostcode: AddressesByPostcode;
};

/**
 * A combo of addresses plus the postcode related to the search
 * term used to get them
 */
export type AddressesByPostcode = {
    __typename?: 'AddressesByPostcode';
    /** A list of addresses */
    addresses: Array<Maybe<Address>>;
    /**
     * The postcode related to the addresses
     * @deprecated Please use the argument instead of this field
     */
    postcode: Scalars['String'];
};

export type AgentBranch = {
    __typename?: 'AgentBranch';
    address?: Maybe<Scalars['String']>;
    branchDetailsUri?: Maybe<Scalars['String']>;
    branchId: Scalars['ID'];
    /** Company ID of Agent - a company can have N amount of branches */
    companyId?: Maybe<Scalars['Int']>;
    /** Group ID of Agent - a group can have N amount of companies */
    groupId?: Maybe<Scalars['Int']>;
    branchResultsUri?: Maybe<Scalars['String']>;
    logoUrl?: Maybe<Scalars['String']>;
    memberType: MemberType;
    name: Scalars['String'];
    phone?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    attributes: BranchAttributes;
};

export type AgentExclusions = ExclusionByCategory | ExclusionError;

export type AgentExclusionsCriteria = {
    listingId?: Maybe<Scalars['Int']>;
    branchId?: Maybe<Scalars['Int']>;
    companyId?: Maybe<Scalars['Int']>;
    groupId?: Maybe<Scalars['Int']>;
};

/** Data associated with a query for ONLY the URLS of links used on the LSRP list view */
export type AlertFrequencyOption = {
    __typename?: 'AlertFrequencyOption';
    /** i18n label */
    i18NLabelKey?: Maybe<Scalars['String']>;
    /** value */
    value?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY listings search result eCommerce tracking data */
export type AnalyticsEcommerce = {
    __typename?: 'AnalyticsEcommerce';
    /** Current currency code (e.g. "GBP") */
    currencyCode?: Maybe<Scalars['String']>;
    /** event */
    event?: Maybe<Scalars['String']>;
    /** List of all visible listings, including (Listing ID, position within list, and the listing type)  */
    impressions?: Maybe<Array<Maybe<AnalyticsEcommerceImpressions>>>;
};

/** Data associated with a query for ONLY eCommerce tracking impressions */
export type AnalyticsEcommerceImpressions = {
    __typename?: 'AnalyticsEcommerceImpressions';
    /** Listing ID */
    id?: Maybe<Scalars['Int']>;
    /** Name of eCommerce list (e.g. "Search results") */
    list?: Maybe<Scalars['String']>;
    /** Position within eCommerce list (e.g. the first listing has a position of 1) */
    position?: Maybe<Scalars['Int']>;
    /** Type of listing (e.g. "standard", "premium") */
    variant?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY listings search analyics taxonomy */
export type AnalyticsTaxonomy = {
    __typename?: 'AnalyticsTaxonomy';
    /** Current page URL */
    url?: Maybe<Scalars['String']>;
    /** Area name */
    areaName?: Maybe<Scalars['String']>;
    /** Activity */
    activity?: Maybe<Scalars['String']>;
    /** Brand */
    brand?: Maybe<Scalars['String']>;
    /** Country code */
    countryCode?: Maybe<Scalars['String']>;
    /** county area name */
    countyAreaName?: Maybe<Scalars['String']>;
    /** currency code */
    currencyCode?: Maybe<Scalars['String']>;
    /** Listing category */
    listingsCategory?: Maybe<Scalars['String']>;
    /** The secone half of a postcode (e.g the outcode of postcode "E15 2QR" would be "2QR")  */
    outcode?: Maybe<Scalars['String']>;
    /** Array of outcodes. Outcodes are the secone half of a postcode (e.g the outcode of postcode "E15 2QR" would be "2QR") */
    outcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Current page */
    page?: Maybe<Scalars['String']>;
    /** Postal area */
    postalArea?: Maybe<Scalars['String']>;
    /** The number of miles the initial searched term has been extended by.  */
    radius?: Maybe<Scalars['Float']>;
    /** Radius auto expansion */
    radiusAutoexpansion?: Maybe<Scalars['String']>;
    /** Region name (e.g. "South East England") */
    regionName?: Maybe<Scalars['String']>;
    /** resultsSort */
    resultsSort?: Maybe<Scalars['String']>;
    /** searchGuid */
    searchGuid?: Maybe<Scalars['String']>;
    /** searchIdentifier */
    searchIdentifier?: Maybe<Scalars['String']>;
    /** searchLocation */
    searchLocation?: Maybe<Scalars['String']>;
    /** section */
    section?: Maybe<Scalars['String']>;
    /** The type of view (e.g. "list" or "map") */
    viewType?: Maybe<Scalars['String']>;
    /** Number of standard results */
    searchResultsCount?: Maybe<Scalars['Int']>;
    /** Number of expanded search results */
    expandedResultsCount?: Maybe<Scalars['Int']>;
    /** Sum of standard and expanded search results */
    totalResults?: Maybe<Scalars['Int']>;
    /** totalResultsWasLimited */
    totalResultsWasLimited?: Maybe<Scalars['Boolean']>;
    /** Flag highlighting if email all form should display */
    emailAllFormShown?: Maybe<Scalars['Boolean']>;
    /** Flag highlighting if email all agents form should display */
    emailAllTotalAgents?: Maybe<Scalars['Int']>;
    /** Maximum price filter value */
    priceMax?: Maybe<Scalars['String']>;
    /** Minimum price filter value */
    priceMin?: Maybe<Scalars['String']>;
    /** Maximum bedrooms filter value */
    bedsMax?: Maybe<Scalars['String']>;
    /** Minimum bedrooms filter value */
    bedsMin?: Maybe<Scalars['String']>;
    /** Property type filter (e.g. "Flats", "Houses", "Retirement", "Bungalows", "Properties (all types)") */
    propertyType?: Maybe<Scalars['String']>;
    /** "Searched location" */
    location?: Maybe<Scalars['String']>;
};

/** Analytics tracking */
export type AnalyticsTracking = {
    __typename?: 'AnalyticsTracking';
    /** Metadata - across resolvers */
    metaData?: Maybe<MetaData>;
    /** Taxonomy analytics for tracking */
    taxonomy?: Maybe<DdpTaxonomy>;
    /** Ecommerce analytics for tracking */
    ecommerce?: Maybe<DdpEcommerce>;
};

/** The response object for the areaName Query */
export type Area = {
    __typename?: 'Area';
    geoType?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name?: Maybe<Scalars['String']>;
    shortName?: Maybe<Scalars['String']>;
};

/** Data object defining article content model. */
export type Article = {
    __typename?: 'Article';
    author?: Maybe<Author>;
    body?: Maybe<RichText>;
    category: ArticleCategory;
    contentType: Scalars['String'];
    ctaSection?: Maybe<Cta>;
    enableComments?: Maybe<Scalars['Boolean']>;
    enableRedirect: Scalars['Boolean'];
    heroImage: ContentfulImage;
    id: Scalars['ID'];
    keyTakeaways?: Maybe<RichText>;
    metaDescription?: Maybe<Scalars['String']>;
    publicationDateAndTime: Scalars['String'];
    redirectUrl?: Maybe<Scalars['String']>;
    relatedArticles?: Maybe<Array<Maybe<ArticleSummary>>>;
    slug: Scalars['String'];
    snippet: Scalars['String'];
    title: Scalars['String'];
    topicTags?: Maybe<Array<Maybe<ArticleTag>>>;
};

/** Data object defining article category collection content model. */
export type ArticleCategories = {
    __typename?: 'ArticleCategories';
    items: Array<Maybe<ArticleCategory>>;
    limit: Scalars['Int'];
    skip: Scalars['Int'];
    total: Scalars['Int'];
};

/** Data object defining article category content model. */
export type ArticleCategory = {
    __typename?: 'ArticleCategory';
    categoryImage: ContentfulImage;
    description: Scalars['String'];
    metaDescription: Scalars['String'];
    name: Scalars['String'];
    slug: Scalars['String'];
};

/** Union type for fetching category object and potential error statuses. */
export type ArticleCategoryResult = ArticleCategory | CmsError;

/** Data object defining article collection content model. */
export type ArticleCollection = {
    __typename?: 'ArticleCollection';
    articles?: Maybe<Articles>;
    categoryFilter?: Maybe<Array<Maybe<ArticleCategory>>>;
    description: Scalars['String'];
    groupBy: Array<Maybe<ArticleTag>>;
    hideTitleAndDescription: Scalars['Boolean'];
    id: Scalars['ID'];
    title: Scalars['String'];
};

/** Data object defining article collection content model. */
export type ArticleCollectionArticlesArgs = {
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

/** Union type for fetching article collection object and potential error statuses. */
export type ArticleCollectionResult = ArticleCollection | CmsError;

/** Union type for fetching article objects and potential error statuses. */
export type ArticleResult = Article | InvalidInputError;

/** Data object defining article summary content model. */
export type ArticleSummary = {
    __typename?: 'ArticleSummary';
    category: ArticleCategory;
    heroImage: ContentfulImage;
    id: Scalars['ID'];
    publicationDateAndTime: Scalars['String'];
    slug: Scalars['String'];
    snippet: Scalars['String'];
    title: Scalars['String'];
};

/** Data object defining article tag content model. */
export type ArticleTag = {
    __typename?: 'ArticleTag';
    articles: Articles;
    id: Scalars['ID'];
    label: Scalars['String'];
    slug: Scalars['String'];
};

/** Data object defining article tag content model. */
export type ArticleTagArticlesArgs = {
    category?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

/** Article tag object error status enumerations. */
export enum ArticleTagErrorStatusCode {
    ArticleTagNotFound = 'article_tag_not_found'
}

/** Data object defining article tag error statuses. */
export type ArticleTagInvalidInputError = {
    __typename?: 'ArticleTagInvalidInputError';
    errorCode: ArticleTagErrorStatusCode;
};

/** Union type for fetching artice tag objects and potential error statuses. */
export type ArticleTagResult = ArticleTag | ArticleTagInvalidInputError;

/** Data object defining article summary collection content model. */
export type Articles = {
    __typename?: 'Articles';
    items: Array<Maybe<ArticleSummary>>;
    limit: Scalars['Int'];
    skip: Scalars['Int'];
    total: Scalars['Int'];
};

export type AskingPrice = {
    __typename?: 'AskingPrice';
    meanValue?: Maybe<Scalars['Float']>;
    numProperties?: Maybe<Scalars['Int']>;
};

export type AskingPrices = {
    __typename?: 'AskingPrices';
    forSale?: Maybe<AskingPrice>;
    toRent?: Maybe<AskingPrice>;
};

export type Attributes = {
    __typename?: 'Attributes';
    bathrooms?: Maybe<Scalars['Int']>;
    bedrooms?: Maybe<Scalars['Int']>;
    livingRooms?: Maybe<Scalars['Int']>;
    tenure?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
};

/** Deprecated (can now be replaced with Attributes) */
export type AttributesV2 = {
    __typename?: 'AttributesV2';
    bathrooms?: Maybe<Scalars['Int']>;
    bedrooms?: Maybe<Scalars['Int']>;
    livingRooms?: Maybe<Scalars['Int']>;
    tenure?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
};

/** Data object defining author content model. */
export type Author = {
    __typename?: 'Author';
    articles: Articles;
    authorBio?: Maybe<RichText>;
    authorImage: ContentfulImage;
    authorName: Scalars['String'];
    authorSlug: Scalars['String'];
    id: Scalars['ID'];
    jobTitle?: Maybe<Scalars['String']>;
    twitterHandle?: Maybe<Scalars['String']>;
};

/** Data object defining author content model. */
export type AuthorArticlesArgs = {
    category?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

/**
 * Data object defining author details content model. This is a repeatition of
 * Author type however AuthorDetails is a specificed type used in downstream
 * quries.
 */
export type AuthorDetails = {
    __typename?: 'AuthorDetails';
    authorBio?: Maybe<RichText>;
    authorImage?: Maybe<ContentfulImage>;
    authorName?: Maybe<Scalars['String']>;
    authorSlug?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    jobTitle?: Maybe<Scalars['String']>;
    twitterHandle?: Maybe<Scalars['String']>;
};

/** Author object error status enumerations. */
export enum AuthorErrorStatusCode {
    AuthorNotFound = 'author_not_found'
}

/** Data object defining author error statuses. */
export type AuthorInvalidInputError = {
    __typename?: 'AuthorInvalidInputError';
    errorCode: AuthorErrorStatusCode;
};

/** Union type for fetching authors objects and potential error statuses. */
export type AuthorResult = Author | AuthorInvalidInputError;

/** Data object defining a collection of author content models. */
export type Authors = {
    __typename?: 'Authors';
    items: Array<Maybe<Author>>;
    limit: Scalars['Int'];
    skip: Scalars['Int'];
    total: Scalars['Int'];
};

export type BackToResultsLink = {
    __typename?: 'BackToResultsLink';
    linkType?: Maybe<BackToResultsLinkType>;
    uri?: Maybe<Scalars['String']>;
};

export enum BackToResultsLinkType {
    Personalised = 'personalised',
    Geo = 'geo'
}

/** Returns results on fetching multiple listings */
export type BaseListings = {
    __typename?: 'BaseListings';
    listings: Array<ListingDetails>;
};

/** Multiple listings or an error */
export type BaseListingsResponse = BaseListings | ListingResultError;

/** Best time to call */
export enum BestTimeToCallType {
    Anytime = 'anytime',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Morning = 'morning'
}

/** Data associated with a query for ONLY a branch relating to a single listing */
export type Branch = {
    __typename?: 'Branch';
    /** Branch details URI */
    branchDetailsUri?: Maybe<Scalars['String']>;
    /** Branch Id */
    branchId?: Maybe<Scalars['Int']>;
    /** URL of branch logo */
    logoUrl?: Maybe<Scalars['String']>;
    /** Branch name */
    name?: Maybe<Scalars['String']>;
    /** Branch phone number */
    phone?: Maybe<Scalars['String']>;
};

export type BranchAttributes = {
    __typename?: 'BranchAttributes';
    embeddedContentIsBlacklisted: Scalars['Boolean'];
};

export type BranchesValidation = {
    __typename?: 'BranchesValidation';
    requiredError?: Maybe<Scalars['Boolean']>;
};

export type Breadcrumbs = {
    __typename?: 'Breadcrumbs';
    label?: Maybe<Scalars['String']>;
    tracking?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
    i18nLabelKey?: Maybe<Scalars['String']>;
    noAppend?: Maybe<Scalars['Int']>;
};

/** Data object defining button content model. */
export type Button = {
    __typename?: 'Button';
    buttonLabel?: Maybe<Scalars['String']>;
    buttonUrl?: Maybe<Scalars['String']>;
    primaryButton?: Maybe<Scalars['Boolean']>;
};

/** Union type for fetching cms objects and potential error statuses. */
export type CmsEntry = CmsError | Article | Chapter | Guide;

/** Data object defining cms error statuses. */
export type CmsError = {
    __typename?: 'CMSError';
    errorCode: CmsErrorCodes;
};

/** CMS error status enumerations. */
export enum CmsErrorCodes {
    EntryNotFound = 'ENTRY_NOT_FOUND'
}

/** Data object defining chapter content model. */
export type Chapter = {
    __typename?: 'Chapter';
    buttonLabel: Scalars['String'];
    content: Array<Maybe<ArticleCollection>>;
    contentType: Scalars['String'];
    description: Scalars['String'];
    featuredArticles: Array<Maybe<ArticleSummary>>;
    featuredMedia: ContentfulImage;
    guide: GuideResult;
    icon: Scalars['String'];
    id: Scalars['ID'];
    metaDescription: Scalars['String'];
    slug: Scalars['String'];
    title: Scalars['String'];
};

/** Chapter object error status enumerations. */
export enum ChapterErrorStatusCode {
    ChapterNotFound = 'chapter_not_found'
}

/** Data object defining chapter error statuses. */
export type ChapterInvalidInputError = {
    __typename?: 'ChapterInvalidInputError';
    errorCode: ChapterErrorStatusCode;
};

/** Union type for fetching chapter objects and potential error statuses. */
export type ChapterResult = Chapter | ChapterInvalidInputError;

export enum ConfidenceLevel {
    Low = 'LOW',
    Medium = 'MEDIUM',
    High = 'HIGH'
}

export type ConsentAgreementInput = {
    /** The id of the consent agreement stored in api-notifications-consent */
    consentId: Scalars['String'];
    /**
     * The specific text that the user agreed to. It is required in addition to the above as
     * parameterized consentText is allowed.
     * For example the text might be "I agree to receive marketing emails for property 1234"
     * This needs to be checked against the consentText in api-notifications-consent to guard against
     * unexpected changes.
     */
    consentText: Scalars['String'];
    /**
     * If the user is consenting to receive communications for a particular listing/property/alert etc
     * then this is required. It should be filled with the id of that particular thing. In this way,
     * you can independently consent to communications for different things.
     */
    entityId?: Maybe<Scalars['String']>;
    /**
     * If the user is consenting to receive communications for multiple listings/properties/alerts etc
     * then this is required. It should be filled with the ids of those particular things.
     */
    entityIds?: Maybe<Array<Scalars['String']>>;
};

export type ConsentsInput = {
    consentName: Scalars['String'];
    consentGiven: Scalars['Boolean'];
};

export enum ContactPreference {
    NoPreference = 'NO_PREFERENCE',
    Phone = 'PHONE',
    Email = 'EMAIL'
}

export enum ContactTimePreference {
    NoPreference = 'NO_PREFERENCE',
    Morning = 'MORNING',
    Afternoon = 'AFTERNOON',
    Evening = 'EVENING'
}

/** Common data object defining Contentful image content model. */
export type ContentfulImage = {
    __typename?: 'ContentfulImage';
    altText?: Maybe<Scalars['String']>;
    focalPoint?: Maybe<Scalars['JSON']>;
    url: Scalars['String'];
};

/** Data object defining call to action content model. */
export type Cta = {
    __typename?: 'Cta';
    button?: Maybe<Button>;
    description?: Maybe<Scalars['String']>;
    image: ContentfulImage;
    title?: Maybe<Scalars['String']>;
};

/** Development details ecommerce, analytics stuff */
export type DdpEcommerce = {
    __typename?: 'DDPEcommerce';
    outcode?: Maybe<Scalars['String']>;
};

/** Development details taxonomy, analytics stuff */
export type DdpTaxonomy = {
    __typename?: 'DDPTaxonomy';
    groupId?: Maybe<Scalars['String']>;
    companyId?: Maybe<Scalars['String']>;
};

/** Delete a saved search, and all associated alerts */
export type DeleteSavedSearchInput = {
    /** ID of the search to delete */
    id: Scalars['ID'];
};

/** Developer info */
export type Developer = {
    __typename?: 'Developer';
    /** Metadata - across resolvers */
    metaData?: Maybe<MetaData>;
    name?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
};

export type DiscoverMore = {
    __typename?: 'DiscoverMore';
    findAgentsUri?: Maybe<Scalars['String']>;
    housePricesUri?: Maybe<Scalars['String']>;
};

export type DynamicAgentPhone =
    | DynamicAgentPhoneResultSuccess
    | DynamicAgentPhoneResultError;

export type DynamicAgentPhoneInput = {
    branchId: Scalars['Int'];
    listingId: Scalars['Int'];
};

export type DynamicAgentPhoneResultError = {
    __typename?: 'DynamicAgentPhoneResultError';
    errorCode: DynamicAgentPhoneResultErrorCode;
};

export enum DynamicAgentPhoneResultErrorCode {
    AuthFailure = 'auth_failure',
    NoNumbersFound = 'no_numbers_found',
    ApplicationError = 'application_error',
    RequestTimeout = 'request_timeout',
    UnknownError = 'unknown_error'
}

export type DynamicAgentPhoneResultSuccess = {
    __typename?: 'DynamicAgentPhoneResultSuccess';
    phone: Scalars['String'];
};

export type Epc = {
    __typename?: 'EPC';
    image?: Maybe<Array<Media>>;
    pdf?: Maybe<Array<Media>>;
};

/** Used to edit an alert related to a saved search. Note: To 'delete' an alert, change the frequency to null. */
export type EditSavedSearchAlertInput = {
    /**
     * Frequency at which the user will recieve alerts for the channel, in days.
     * 0 means the alerts are instant.
     * Null means the user will not recieve alerts.
     * eg. 1 means 1 alert per day, and 7 means one alert per week
     */
    frequency?: Maybe<Scalars['Int']>;
};

export type EmailAll = {
    __typename?: 'EmailAll';
    action?: Maybe<Scalars['String']>;
    branches?: Maybe<Array<Maybe<EmailAllBranchContact>>>;
    branchesValidation?: Maybe<BranchesValidation>;
    formConfig?: Maybe<EmailAllFormConfig>;
    showCaptcha?: Maybe<Scalars['Boolean']>;
};

export type EmailAllBranchContact = {
    __typename?: 'EmailAllBranchContact';
    checked?: Maybe<Scalars['Boolean']>;
    featured?: Maybe<Scalars['Boolean']>;
    label?: Maybe<Scalars['String']>;
    logo?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    telephone?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['Int']>;
};

export type EmailAllDetails = {
    branches?: Maybe<Array<Maybe<Scalars['Int']>>>;
    email?: Maybe<Scalars['String']>;
    message?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    status?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
};

export type EmailAllFormConfig = {
    __typename?: 'EmailAllFormConfig';
    fields?: Maybe<Array<Maybe<EmailAllFormConfigFields>>>;
};

export type EmailAllFormConfigFields = {
    __typename?: 'EmailAllFormConfigFields';
    fieldset?: Maybe<EmailAllFormConfigFieldset>;
};

export type EmailAllFormConfigFieldset = {
    __typename?: 'EmailAllFormConfigFieldset';
    fields?: Maybe<Array<Maybe<EmailAllFormField>>>;
    hideLegend?: Maybe<Scalars['Boolean']>;
    i18NLegendKey?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
};

export type EmailAllFormField = {
    __typename?: 'EmailAllFormField';
    name?: Maybe<Scalars['String']>;
    placeholder?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['String']>;
    i18NLabelKey?: Maybe<Scalars['String']>;
    maxlength?: Maybe<Scalars['String']>;
    optional?: Maybe<Scalars['Boolean']>;
    validationData?: Maybe<EmailAllFormFieldValidation>;
    options?: Maybe<Array<Maybe<EmailAllOption>>>;
};

export type EmailAllFormFieldValidation = {
    __typename?: 'EmailAllFormFieldValidation';
    pattern?: Maybe<Scalars['String']>;
    patternError?: Maybe<Scalars['Boolean']>;
    required?: Maybe<Scalars['Boolean']>;
    requiredError?: Maybe<Scalars['Boolean']>;
};

export type EmailAllOption = {
    __typename?: 'EmailAllOption';
    disabled?: Maybe<Scalars['Boolean']>;
    i18NLabelKey?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    selected?: Maybe<Scalars['Boolean']>;
    value?: Maybe<Scalars['String']>;
};

export type EmailAllResult = {
    __typename?: 'EmailAllResult';
    branches?: Maybe<Array<Maybe<EmailAllResultBranches>>>;
    leadIdentifier?: Maybe<Scalars['String']>;
    message?: Maybe<Scalars['String']>;
    trackingObjects?: Maybe<Array<Maybe<EmailAllResultTracking>>>;
};

export type EmailAllResultBranches = {
    __typename?: 'EmailAllResultBranches';
    address?: Maybe<Scalars['String']>;
    branchDetailsUri?: Maybe<Scalars['String']>;
    branchDetailsUrl?: Maybe<Scalars['String']>;
    branchId?: Maybe<Scalars['Int']>;
    companyId?: Maybe<Scalars['Int']>;
    companyName?: Maybe<Scalars['String']>;
    logoUrl?: Maybe<Scalars['String']>;
    memberType?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
};

export type EmailAllResultEcommerce = {
    __typename?: 'EmailAllResultEcommerce';
    purchase?: Maybe<EmailAllResultEcommercePurchase>;
};

export type EmailAllResultEcommerceProduct = {
    __typename?: 'EmailAllResultEcommerceProduct';
    brand?: Maybe<Scalars['String']>;
    category?: Maybe<Scalars['String']>;
    coupon?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['Int']>;
    name?: Maybe<Scalars['String']>;
    position?: Maybe<Scalars['String']>;
    price?: Maybe<Scalars['Int']>;
    quantity?: Maybe<Scalars['String']>;
    variant?: Maybe<Scalars['String']>;
};

export type EmailAllResultEcommercePurchase = {
    __typename?: 'EmailAllResultEcommercePurchase';
    actionField?: Maybe<EmailAllResultEcommercePurchaseAction>;
    products?: Maybe<Array<Maybe<EmailAllResultEcommerceProduct>>>;
};

export type EmailAllResultEcommercePurchaseAction = {
    __typename?: 'EmailAllResultEcommercePurchaseAction';
    affiliation?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['String']>;
    revenue?: Maybe<Scalars['Int']>;
};

export type EmailAllResultTracking = {
    __typename?: 'EmailAllResultTracking';
    ecommerce?: Maybe<EmailAllResultEcommerce>;
};

export type EmailAllSubmission = {
    __typename?: 'EmailAllSubmission';
    emailAll?: Maybe<EmailAll>;
    result?: Maybe<EmailAllResult>;
};

export type EmailLeadFormFields = {
    __typename?: 'EmailLeadFormFields';
    email?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    status?: Maybe<Scalars['String']>;
};

export type EmailLeadInfo = {
    __typename?: 'EmailLeadInfo';
    showCaptcha: Scalars['Boolean'];
    uniqueLeadIdentifier?: Maybe<Scalars['String']>;
    formFields?: Maybe<EmailLeadFormFields>;
};

export type EmailLeadInput = {
    name: Scalars['String'];
    phone: Scalars['String'];
    email: Scalars['String'];
    message?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    senderPropertyStatus?: Maybe<Scalars['String']>;
    interest?: Maybe<Scalars['Boolean']>;
    availability?: Maybe<Array<Maybe<Scalars['String']>>>;
    captchaToken?: Maybe<Scalars['String']>;
    searchIdentifier?: Maybe<Scalars['String']>;
};

export type EmailLeadResponse = {
    __typename?: 'EmailLeadResponse';
    success: Scalars['Boolean'];
    uniqueLeadIdentifier: Scalars['String'];
};

/** Input for setting users email preferences */
export type EmailPreferencesInput = {
    /** Whether users wants to opt for sending news */
    sendNews?: Maybe<Scalars['Boolean']>;
    /** Whether users want to opt for sending offers */
    sendOffers?: Maybe<Scalars['Boolean']>;
};

export type EmbeddedContent = {
    __typename?: 'EmbeddedContent';
    videos?: Maybe<Array<Media>>;
    tours?: Maybe<Array<Media>>;
    smartViewings?: Maybe<Array<Media>>;
    links?: Maybe<Array<Media>>;
};

/** The type of enquiry */
export enum EnquiryType {
    LookingToBuy = 'LOOKING_TO_BUY'
}

/** An object containing info that the front-end can use to index and request full listing-detail objects on demand */
export type EnrichedSavedPropertyId = {
    __typename?: 'EnrichedSavedPropertyId';
    /** E.g. 'commercial', 'residential' */
    category: ListingCategory;
    /** Primary key */
    listingId: Scalars['ID'];
    /** E.g. 'live' */
    publicationStatus: PublicationStatus;
    /** E.g. "2021-08-23T08:45:44.000Z" */
    savedDate: Scalars['DateTime'];
    /** E.g. 'for-sale', 'overseas' */
    section: Scalars['String'];
};

/** Failed response */
export type EnrichedSavedPropertyIdsFail = {
    __typename?: 'EnrichedSavedPropertyIdsFail';
    /** Error code */
    errorCode?: Maybe<EnrichedSavedPropertyIdsFailErrorCode>;
};

/** Failed response error codes */
export enum EnrichedSavedPropertyIdsFailErrorCode {
    /** Saved-Listings API errored getting listings */
    FailedFetchingSavedListings = 'FAILED_FETCHING_SAVED_LISTINGS',
    /** Listing Search API errored (422) trying to get response for user's saved listings */
    ListingSearchBadIdInput = 'LISTING_SEARCH_BAD_ID_INPUT',
    /** Listing Search API errored (404) trying to get response for user's saved listings */
    ListingSearchNotFound = 'LISTING_SEARCH_NOT_FOUND'
}

/** Union of success / fail */
export type EnrichedSavedPropertyIdsResult =
    | EnrichedSavedPropertyIdsSuccess
    | EnrichedSavedPropertyIdsFail;

/** Successful response */
export type EnrichedSavedPropertyIdsSuccess = {
    __typename?: 'EnrichedSavedPropertyIdsSuccess';
    /** Array of the above type */
    enrichedSavedPropertyIds?: Maybe<Array<EnrichedSavedPropertyId>>;
};

export type ExclusionByCategory = {
    __typename?: 'ExclusionByCategory';
    appraisals?: Maybe<Scalars['Boolean']>;
    arrangeViewing?: Maybe<Scalars['Boolean']>;
    broadband?: Maybe<Scalars['Boolean']>;
    createSimilar?: Maybe<Scalars['Boolean']>;
    ebay?: Maybe<Scalars['Boolean']>;
    firstListedDate?: Maybe<Scalars['Boolean']>;
    floorArea?: Maybe<Scalars['Boolean']>;
    google?: Maybe<Scalars['Boolean']>;
    gumtree?: Maybe<Scalars['Boolean']>;
    historicListings?: Maybe<Scalars['Boolean']>;
    longDescriptiononResults?: Maybe<Scalars['Boolean']>;
    marketview?: Maybe<Scalars['Boolean']>;
    nestoria?: Maybe<Scalars['Boolean']>;
    priceChange?: Maybe<Scalars['Boolean']>;
    streetView?: Maybe<Scalars['Boolean']>;
    retirementAgents?: Maybe<Scalars['Boolean']>;
    variableCopy?: Maybe<Scalars['Boolean']>;
    trussle?: Maybe<Scalars['Boolean']>;
};

export type ExclusionError = {
    __typename?: 'ExclusionError';
    errorCode: ExclusionErrorStatusCode;
};

export enum ExclusionErrorStatusCode {
    ApplicationError = 'application_error',
    RequestTimeout = 'request_timeout',
    BadRequest = 'bad_request',
    UnknownError = 'unknown_error'
}

/** Extends development data */
export type ExtendedDevelopmentData = {
    __typename?: 'ExtendedDevelopmentData';
    descriptionSummary?: Maybe<Scalars['String']>;
    availableFromDate?: Maybe<Scalars['String']>;
    hbfRating?: Maybe<Scalars['Int']>;
    developerDescription?: Maybe<Scalars['String']>;
    keyDevelopmentFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
    propertyTypesAvailable?: Maybe<Array<Maybe<Scalars['String']>>>;
    launchDate?: Maybe<Scalars['String']>;
    launchDateSeason?: Maybe<Scalars['String']>;
};

/** Data object defining faq content model. */
export type Faq = {
    __typename?: 'Faq';
    answer: RichText;
    question: Scalars['String'];
};

export type Favourites = {
    __typename?: 'Favourites';
    listings?: Maybe<Array<Maybe<Scalars['ID']>>>;
    properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** Data associated with a query for ONLY feature relating to a single listing */
export type Feature = {
    __typename?: 'Feature';
    /** Feature Icon ID */
    iconId?: Maybe<Scalars['String']>;
    /** Feature content */
    content?: Maybe<Scalars['Int']>;
};

export type FeatureFlag = {
    __typename?: 'FeatureFlag';
    furnishedState?: Maybe<Label>;
    studentFriendly: Scalars['Boolean'];
    tenure?: Maybe<Label>;
    availableFromDate?: Maybe<Scalars['String']>;
};

export type FeatureHighlight = {
    __typename?: 'FeatureHighlight';
    description?: Maybe<Scalars['String']>;
    label: Scalars['String'];
};

export type Features = {
    __typename?: 'Features';
    bullets?: Maybe<Array<Scalars['String']>>;
    flags?: Maybe<FeatureFlag>;
    highlights?: Maybe<Array<FeatureHighlight>>;
};

/** A non-exhaustive list of possible feed types */
export type FeedItem = FeedListingItem;

/** A listing item for the results feed */
export type FeedListingItem = {
    __typename?: 'FeedListingItem';
    /** All listing data */
    listing?: Maybe<Listing>;
    /** Used to determine the style of the listing, currently REGULAR, FEATURED */
    presentationType?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY listings filters */
export type Filters = {
    __typename?: 'Filters';
    /** A form action path (e.g. "/search") */
    action?: Maybe<Scalars['String']>;
    /** Collection of filter fields */
    fields?: Maybe<Array<Maybe<FiltersFields>>>;
};

/** Data associated with a query for ONLY listings filter fields */
export type FiltersFields = {
    __typename?: 'FiltersFields';
    /** Filter group, applicable to filters with multiple fields (e.g. "min-bedrooms", "max-bedroom") */
    group?: Maybe<Scalars['String']>;
    /** Filter name (e.g. "max-bedrooms", "property-added") */
    fieldName?: Maybe<Scalars['String']>;
    /** Filter label */
    label?: Maybe<Scalars['String']>;
    /** Flag indicating if filter is required */
    isRequired?: Maybe<Scalars['Boolean']>;
    /** Input field type (e.g. "radio", "select") */
    inputType?: Maybe<Scalars['String']>;
    /** Filter placeholder text */
    placeholder?: Maybe<Scalars['String']>;
    /** Flag indicating if filter can have multiple values (e.g. filter is a checkbox) */
    allowMultiple?: Maybe<Scalars['Boolean']>;
    /** Form input field options */
    options?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Value of form field (e.g. "residential") */
    value?: Maybe<Scalars['String']>;
};

/** Floor area information about the size of the property listed */
export type FloorArea = {
    __typename?: 'FloorArea';
    label: Scalars['String'];
    range?: Maybe<FloorAreaRange>;
    units: Scalars['String'];
    unitsLabel: Scalars['String'];
    value?: Maybe<Scalars['Float']>;
    valueLabel?: Maybe<Scalars['String']>;
};

/**
 * Floor area range in case the Listing has a range of possible sizes
 * (commercial listings to rent for example).
 */
export type FloorAreaRange = {
    __typename?: 'FloorAreaRange';
    maxValue: Scalars['Float'];
    maxValueLabel: Scalars['String'];
    minValue: Scalars['Float'];
    minValueLabel: Scalars['String'];
};

export type FloorPlan = {
    __typename?: 'FloorPlan';
    image?: Maybe<Array<Media>>;
    links?: Maybe<Array<LinkData>>;
    pdf?: Maybe<Array<Media>>;
};

/** Data associated with a query for ONLY listings polygons */
export type GeoData = {
    __typename?: 'GeoData';
    /** Alias for a search identifier (e.g. search identifier "london/forest-hill" has an alias of "Forest Hill") */
    alias?: Maybe<Scalars['String']>;
    /** Alias ID */
    aliasId?: Maybe<Scalars['Float']>;
    /** Returns array of alias IDs */
    aliasIds?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Area ID  */
    areaId?: Maybe<Scalars['Float']>;
    /** Area name  */
    areaName?: Maybe<Scalars['String']>;
    /** Area street ID  */
    areaStreetId?: Maybe<Scalars['Float']>;
    /** Coordinates of search result (e.g. search identifier "london/forst-hill" has coordinates of "[\"-0.048951\", \"51.441663\"]") */
    coordinates?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** The internal ID for a country (e.g. England has an ID of "1") */
    countryId?: Maybe<Scalars['Float']>;
    /** The internal ID relating of a UK county */
    countyAreaId?: Maybe<Scalars['Float']>;
    /** The name of a UK county */
    countyAreaName?: Maybe<Scalars['String']>;
    /** Identifier is the a taxonomy path used to identify a specific Geo (e.g. "london/forest-hill") */
    identifier?: Maybe<Scalars['String']>;
    /** The second half of a postcode (e.g the incode of postcode "E15 2QR" would be "2QR") */
    incode?: Maybe<Scalars['String']>;
    /** Local area code (e.g. "City of london" has a LA Code of "00AA") */
    laCode?: Maybe<Scalars['String']>;
    /** Identifiers taxonomy level (e.g. level 1 would be "london", level 2 would be "london/forest-hill" ) */
    level?: Maybe<Scalars['Float']>;
    /** The first half of a postcode (e.g the outcode of postcode "E15 2QR" would be "E15") */
    outcode?: Maybe<Scalars['String']>;
    /** The ID of the town (e.g. "123") */
    postTownId?: Maybe<Scalars['Float']>;
    /** The name of the town (e.g. "Oxford")  */
    postTownName?: Maybe<Scalars['String']>;
    /** Postal area */
    postalArea?: Maybe<Scalars['String']>;
    /** Region ID (e.g. "123") */
    regionId?: Maybe<Scalars['Float']>;
    /** Region name (e.g. "South East England") */
    regionName?: Maybe<Scalars['String']>;
};

export type GeoSuggestion = {
    __typename?: 'GeoSuggestion';
    geoIdentifier?: Maybe<Scalars['String']>;
    geoLabel?: Maybe<Scalars['String']>;
    geoSubLabel?: Maybe<Scalars['String']>;
};

/** Data object defining goverment scheme content model. */
export type GovSchemesData = {
    __typename?: 'GovSchemesData';
    faqs?: Maybe<Array<Maybe<Faq>>>;
    header?: Maybe<Header>;
    howSchemeWorks?: Maybe<RichTextAndImage>;
    keyBenefits?: Maybe<KeyBenefitsDetails>;
    priceCaps?: Maybe<RichText>;
    prosAndConsDetails?: Maybe<ProsAndConsDetails>;
    quote?: Maybe<Quote>;
    schemeDescription?: Maybe<RichTextAndImage>;
    schemeTypeComparisonTable?: Maybe<Table>;
    schemeVersionComparisonTable?: Maybe<Table>;
    secondarySearch?: Maybe<SecondarySearch>;
    seoSearchLinks?: Maybe<SeoSearchLinks>;
};

/** Data object defining guide content model. */
export type Guide = {
    __typename?: 'Guide';
    chapters: Array<Maybe<Chapter>>;
    contentType: Scalars['String'];
    description: Scalars['String'];
    id: Scalars['ID'];
    metaDescription: Scalars['String'];
    slug: Scalars['String'];
    subtitle?: Maybe<Scalars['String']>;
    title: Scalars['String'];
};

/** Guide object error status enumerations. */
export enum GuideErrorStatusCode {
    GuideNotFound = 'GUIDE_NOT_FOUND'
}

/** Data object defining guide error statuses. */
export type GuideInvalidInputError = {
    __typename?: 'GuideInvalidInputError';
    errorCode: GuideErrorStatusCode;
};

/** Union type for fetching guide objects and potential error statuses. */
export type GuideResult = Guide | GuideInvalidInputError;

/** Data object defining header content model. */
export type Header = {
    __typename?: 'Header';
    heading?: Maybe<Scalars['String']>;
    heroImage?: Maybe<Scalars['String']>;
    searchButtonText?: Maybe<Scalars['String']>;
    searchFilterType?: Maybe<Scalars['String']>;
    searchLabel?: Maybe<Scalars['String']>;
    subHeading?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY a listings highlights */
export type Highlight = {
    __typename?: 'Highlight';
    /** Description */
    description?: Maybe<Scalars['String']>;
    /** Label */
    label?: Maybe<Scalars['String']>;
    /** URL */
    url?: Maybe<Scalars['String']>;
};

export type HistoricImage = {
    __typename?: 'HistoricImage';
    thumbnail: Scalars['String'];
    medium: Scalars['String'];
    large: Scalars['String'];
};

export type HistoricListing = {
    __typename?: 'HistoricListing';
    attributes?: Maybe<Attributes>;
    date: Scalars['String'];
    floorplans?: Maybe<Array<HistoricImage>>;
    images?: Maybe<Array<HistoricImage>>;
    price: Scalars['Int'];
    priceType?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
};

export type HistoricSale = {
    __typename?: 'HistoricSale';
    date: Scalars['String'];
    numericChange?: Maybe<Scalars['Int']>;
    percentageChange?: Maybe<Scalars['Float']>;
    price: Scalars['Int'];
};

export type HistoricalEstimate = {
    __typename?: 'HistoricalEstimate';
    overMonth?: Maybe<Scalars['String']>;
    value?: Maybe<Scalars['Int']>;
    pctChangeSince?: Maybe<Scalars['Float']>;
    date?: Maybe<Scalars['String']>;
    changeSince?: Maybe<Scalars['Int']>;
};

export type HistoricalSales = {
    __typename?: 'HistoricalSales';
    overYear?: Maybe<Scalars['String']>;
    mean?: Maybe<Scalars['Float']>;
    newBuilds?: Maybe<Scalars['Int']>;
    numSales?: Maybe<Scalars['Int']>;
};

export type History = {
    __typename?: 'History';
    soldPricesDataSource?: Maybe<Scalars['String']>;
    historicListings?: Maybe<Array<HistoricListing>>;
    historicSales?: Maybe<Array<HistoricSale>>;
};

/** Data object defining homepage content model. */
export type Homepage = {
    __typename?: 'Homepage';
    brandHeadline: Scalars['String'];
    h1TitleTag: Scalars['String'];
    heroImage: ContentfulImage;
};

/** Union type for fetching homepage objects and potential error statuses. */
export type HomepageResult = Homepage | CmsError;

/** The type of house. For filtering */
export enum HouseType {
    All = 'ALL',
    Detached = 'DETACHED',
    Flat = 'FLAT',
    SemiDetached = 'SEMI_DETACHED',
    Terraced = 'TERRACED'
}

/** Common interface between New Homes Listing and Listing Details */
export type IListing = {
    counts: RoomCount;
    floorArea?: Maybe<FloorArea>;
    /** Whether the Help to Buy scheme is available */
    helpToBuy?: Maybe<Scalars['Boolean']>;
    listingId: Scalars['ID'];
    pricing: ListingPricing;
    propertyType?: Maybe<Scalars['String']>;
    section?: Maybe<Scalars['String']>;
    /** Whether the Shared Ownership scheme is available */
    sharedOwnership?: Maybe<Scalars['Boolean']>;
};

/** Data associated with a query for ONLY a image relating to a single listing */
export type Image = {
    __typename?: 'Image';
    /** Image URL */
    src?: Maybe<Scalars['String']>;
    /** Image caption */
    caption?: Maybe<Scalars['String']>;
    /** List of responsive images */
    responsiveImgList?: Maybe<Array<Maybe<ResponsiveImg>>>;
};

/** Object holding information on related error code */
export type InvalidInputError = {
    __typename?: 'InvalidInputError';
    errorCode: ItemErrorStatusCode;
};

export type Item = {
    __typename?: 'Item';
    id: Scalars['ID'];
    subnavs?: Maybe<Array<Maybe<Subnav>>>;
    order?: Maybe<Scalars['Int']>;
    label?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
    i18nLabelKey?: Maybe<Scalars['String']>;
    tracking?: Maybe<Scalars['String']>;
};

/** Various object error status enumerations. */
export enum ItemErrorStatusCode {
    ArticleNotFound = 'ARTICLE_NOT_FOUND',
    SmallPrintNotFound = 'SMALL_PRINT_NOT_FOUND'
}

/** Data object defining key benefit content model. */
export type KeyBenefit = {
    __typename?: 'KeyBenefit';
    description?: Maybe<Scalars['String']>;
    headline?: Maybe<Scalars['String']>;
    icon?: Maybe<Scalars['String']>;
};

/** Data object defining key benefits collection content model. */
export type KeyBenefitsDetails = {
    __typename?: 'KeyBenefitsDetails';
    items?: Maybe<Array<Maybe<KeyBenefit>>>;
    title?: Maybe<Scalars['String']>;
};

export type Label = {
    __typename?: 'Label';
    name: Scalars['String'];
    label: Scalars['String'];
};

/** Deprecated */
export type LastSaleData = {
    __typename?: 'LastSaleData';
    date?: Maybe<Scalars['DateTime']>;
    price?: Maybe<Scalars['Int']>;
};

export type Link = {
    __typename?: 'Link';
    category?: Maybe<Scalars['String']>;
    geo?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    section?: Maybe<Scalars['String']>;
    transactionType?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
};

export type LinkData = {
    __typename?: 'LinkData';
    label: Scalars['String'];
    url: Scalars['String'];
};

/** Data associated with a query for ONLY the URLS of links used on the LSRP list view */
export type Links = {
    __typename?: 'Links';
    /** URL for saving a search */
    saveSearch?: Maybe<Scalars['String']>;
    /** URL for creating an alert */
    createAlert?: Maybe<Scalars['String']>;
    /** URL for map view */
    mapView?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY a single listing */
export type Listing = {
    __typename?: 'Listing';
    /** Listing ID */
    listingId: Scalars['ID'];
    /** Listing asking price */
    price?: Maybe<Scalars['String']>;
    /** Listing asking price long form */
    priceTitle?: Maybe<Scalars['String']>;
    /** Listing asking price short form */
    shortPriceTitle?: Maybe<Scalars['String']>;
    /** Listing rent price in pppw ppw */
    alternativeRentFrequencyLabel?: Maybe<Scalars['String']>;
    /** Change in asking price */
    priceDrop?: Maybe<PriceDrop>;
    /** Agent branch name */
    branch?: Maybe<Branch>;
    /** Listing title */
    title?: Maybe<Scalars['String']>;
    /** Listing address */
    address?: Maybe<Scalars['String']>;
    /** Date listing was published */
    publishedOnLabel?: Maybe<Scalars['String']>;
    /** Data listing was published */
    publishedOn?: Maybe<Scalars['String']>;
    /** Listing available date */
    availableFrom?: Maybe<Scalars['String']>;
    /** Tags relating to listing (e.g. "New home") */
    tags?: Maybe<Array<Maybe<Tag>>>;
    /** Listing features */
    features?: Maybe<Array<Maybe<Feature>>>;
    /** Listing images */
    image?: Maybe<Image>;
    /** Flag */
    flag?: Maybe<Scalars['String']>;
    /** Nearby transport links */
    transports?: Maybe<Array<Maybe<Transport>>>;
    /** Indicates if the listing is premium */
    isPremium?: Maybe<Scalars['Boolean']>;
    /** Additional images of the property */
    otherPropertyImages?: Maybe<Array<Maybe<SubImage>>>;
    /** Highlights additional attributes about the property (e.g. "retirement home") */
    highlights?: Maybe<Array<Maybe<Highlight>>>;
    /** Display type */
    displayType?: Maybe<Scalars['String']>;
    /** Number of videos */
    numberOfVideos?: Maybe<Scalars['Int']>;
    /** Number of floor plans */
    numberOfFloorPlans?: Maybe<Scalars['Int']>;
    /** Number of images */
    numberOfImages?: Maybe<Scalars['Int']>;
    /** Number of views */
    numberOfViews?: Maybe<Scalars['Int']>;
    /** Video of the property */
    FloatOfVideos?: Maybe<Scalars['Int']>;
    /** Property floor plan */
    FloatOfFloorPlans?: Maybe<Scalars['Int']>;
    /** Property images */
    FloatOfImages?: Maybe<Scalars['Int']>;
    /** Float of views */
    FloatOfViews?: Maybe<Scalars['Int']>;
    /** Listing URI */
    listingUris?: Maybe<ListingUris>;
    /** Featured status */
    featuredType?: Maybe<Scalars['String']>;
    /** Listing location */
    location?: Maybe<ListingLocation>;
    /** Section */
    section?: Maybe<Scalars['String']>;
    /** Indicates if the listing is live */
    publicationStatus: PublicationStatus;
};

export type ListingAnalyticsEcommerce = {
    __typename?: 'ListingAnalyticsEcommerce';
    brand: Scalars['String'];
    category: Scalars['String'];
    id: Scalars['Int'];
    name: Scalars['String'];
    price: Scalars['Float'];
    quantity: Scalars['Int'];
    variant: Scalars['String'];
};

export type ListingAnalyticsTaxonomy = {
    __typename?: 'ListingAnalyticsTaxonomy';
    acorn?: Maybe<Scalars['Int']>;
    acornType?: Maybe<Scalars['Int']>;
    areaName: Scalars['String'];
    bedsMax?: Maybe<Scalars['Int']>;
    bedsMin?: Maybe<Scalars['Int']>;
    branchId?: Maybe<Scalars['Int']>;
    branchLogoUrl?: Maybe<Scalars['String']>;
    branchName: Scalars['String'];
    brandName: Scalars['String'];
    chainFree: Scalars['Boolean'];
    companyId?: Maybe<Scalars['Int']>;
    countryCode: Scalars['String'];
    countyAreaName: Scalars['String'];
    currencyCode: Scalars['String'];
    displayAddress: Scalars['String'];
    furnishedState: Scalars['String'];
    groupId?: Maybe<Scalars['Int']>;
    hasEpc: Scalars['Boolean'];
    hasFloorplan: Scalars['Boolean'];
    incode: Scalars['String'];
    isRetirementHome: Scalars['Boolean'];
    isSharedOwnership: Scalars['Boolean'];
    listingCondition: Scalars['String'];
    listingId: Scalars['Int'];
    listingsCategory: Scalars['String'];
    listingStatus: Scalars['String'];
    location: Scalars['String'];
    memberType: Scalars['String'];
    numBaths?: Maybe<Scalars['Int']>;
    numBeds?: Maybe<Scalars['Int']>;
    numImages: Scalars['Int'];
    numRecepts?: Maybe<Scalars['Int']>;
    outcode: Scalars['String'];
    postalArea: Scalars['String'];
    postTownName: Scalars['String'];
    priceActual?: Maybe<Scalars['Float']>;
    price?: Maybe<Scalars['Float']>;
    priceMax?: Maybe<Scalars['Float']>;
    priceMin?: Maybe<Scalars['Float']>;
    priceQualifier: Scalars['String'];
    propertyHighlight?: Maybe<Scalars['String']>;
    propertyType: Scalars['String'];
    regionName: Scalars['String'];
    section: Scalars['String'];
    sizeSqFeet: Scalars['String'];
    tenure?: Maybe<Scalars['String']>;
    zindex?: Maybe<Scalars['Int']>;
};

export enum ListingCategory {
    Commercial = 'commercial',
    Residential = 'residential'
}

export type ListingData = IListing & {
    __typename?: 'ListingData';
    administrationFees?: Maybe<Scalars['String']>;
    analyticsEcommerce: ListingAnalyticsEcommerce;
    analyticsTaxonomy: ListingAnalyticsTaxonomy;
    adTargeting: ListingAnalyticsTaxonomy;
    branch?: Maybe<AgentBranch>;
    category?: Maybe<ListingCategory>;
    content: MediaContent;
    additionalLinks?: Maybe<Array<MediaOrAdditionalLink>>;
    counts: RoomCount;
    /** Detailed description of the listing. This will be an HTML fragment. */
    detailedDescription?: Maybe<Scalars['String']>;
    /** The address string to be displayed on the website. */
    displayAddress?: Maybe<Scalars['String']>;
    embeddedContent?: Maybe<EmbeddedContent>;
    section?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    /** The Energy Performance Certificate (EPC) ratings of the listing */
    epc?: Maybe<Epc>;
    features?: Maybe<Features>;
    featurePreview?: Maybe<Array<Maybe<Feature>>>;
    floorArea?: Maybe<FloorArea>;
    floorPlan?: Maybe<FloorPlan>;
    /** Listing ID: unique ID for a listing */
    listingId: Scalars['ID'];
    listingUris: ListingUris;
    location?: Maybe<ListingLocation>;
    metaDescription: Scalars['String'];
    metaTitle: Scalars['String'];
    pricing: ListingPricing;
    propertyImage?: Maybe<Array<Media>>;
    statusSummary?: Maybe<ListingStatusSummary>;
    tags?: Maybe<Array<ListingTag>>;
    title: Scalars['String'];
    pointsOfInterest?: Maybe<Array<PointOfInterest>>;
    priceHistory?: Maybe<PriceHistory>;
    viewCount?: Maybe<ViewCount>;
    similarListings?: Maybe<Array<Maybe<Listing>>>;
    /**
     * Similar listings by Criteria
     * First: a list of maybe up to a given maximum (defaults to 4) Listing objects
     * Criteria: search similar listings based on the criteria
     */
    similarListingsByCriteria?: Maybe<Array<Maybe<SimilarListing>>>;
    /**
     * Market Statistics based on our Listing data. It contains the historical estimate, asking prices,
     * recent sales and historic of sales.
     */
    marketStats?: Maybe<MarketStatsResults>;
    emailLead?: Maybe<EmailLeadInfo>;
    publicationStatus?: Maybe<PublicationStatus>;
    imagePreview?: Maybe<Image>;
    publishedOn?: Maybe<Scalars['String']>;
    numberOfImages?: Maybe<Scalars['Int']>;
    transports?: Maybe<Array<Maybe<Transport>>>;
    /** Whether the Help to Buy scheme is available */
    helpToBuy?: Maybe<Scalars['Boolean']>;
    /** Whether the Shared Ownership scheme is available */
    sharedOwnership?: Maybe<Scalars['Boolean']>;
};

export type ListingDataSimilarListingsArgs = {
    first?: Maybe<Scalars['Int']>;
};

export type ListingDataSimilarListingsByCriteriaArgs = {
    first?: Maybe<Scalars['Int']>;
    criteria: SimilarListingsCriteria;
};

export type ListingDetails = ListingData | ListingResultError;

/** Flags indicating we want to include a listing result in the response if it matches the flag */
export enum ListingInclusion {
    /** Return the listing even if it's expired */
    Expired = 'EXPIRED'
}

export type ListingLocation = {
    __typename?: 'ListingLocation';
    coordinates?: Maybe<LocationCoordinates>;
    postalCode?: Maybe<Scalars['String']>;
    countryCode?: Maybe<Scalars['String']>;
    streetName?: Maybe<Scalars['String']>;
    propertyNumberOrName?: Maybe<Scalars['String']>;
    townOrCity?: Maybe<Scalars['String']>;
};

/**
 * The pricing information of the Listing data, contains informations relative to the listing type
 * and section (ie. "for-sale" or "to-rent")
 */
export type ListingPricing = {
    __typename?: 'ListingPricing';
    alternateRentFrequencyPrice?: Maybe<PriceInfo>;
    currencyCode?: Maybe<Scalars['String']>;
    /** The full price 'label' from our 'valueLabel' alongside extra prefix/suffix (ie. price frequencies for Rent) */
    label?: Maybe<Scalars['String']>;
    /**
     * The Float 'real' value Price of our Listing - 'internal' because it will be used for our tracking
     * and other things. If not existant, will default the value to 0.
     */
    internalValue: Scalars['Float'];
    isAuction: Scalars['Boolean'];
    originalCurrencyPrice?: Maybe<PriceInfo>;
    pricePerFloorAreaUnit?: Maybe<PriceInfo>;
    priceQualifierLabel?: Maybe<Scalars['String']>;
    qualifier?: Maybe<Scalars['String']>;
    /**
     * Rent frenquency value: Per annum - 'pa', Per calendar month - 'pcm', Per week - 'pw'
     * Per quarter - 'pq' or Per person per week - 'pppw'
     */
    rentFrequencyLabel?: Maybe<Scalars['String']>;
    /** The Currency + Right formatting of our 'internalValue' (ie. 100000 would give '£100,000') */
    valueLabel?: Maybe<Scalars['String']>;
};

/** Listing result error */
export type ListingResultError = {
    __typename?: 'ListingResultError';
    message?: Maybe<Scalars['String']>;
    errorCode: ListingResultErrorCode;
};

export enum ListingResultErrorCode {
    ApplicationError = 'APPLICATION_ERROR',
    BadRequest = 'BAD_REQUEST',
    RequestTimeout = 'REQUEST_TIMEOUT',
    UnknownError = 'UNKNOWN_ERROR',
    NotFound = 'NOT_FOUND',
    Expired = 'EXPIRED'
}

export enum ListingStatus {
    ForSale = 'for_sale',
    SaleUnderOffer = 'sale_under_offer',
    Sold = 'sold',
    ToRent = 'to_rent',
    RentUnderOffer = 'rent_under_offer',
    Rented = 'rented'
}

export type ListingStatusSummary = {
    __typename?: 'ListingStatusSummary';
    label?: Maybe<Scalars['String']>;
};

export type ListingTag = {
    __typename?: 'ListingTag';
    label: Scalars['String'];
};

export type ListingUris = {
    __typename?: 'ListingUris';
    contact?: Maybe<Scalars['String']>;
    detail?: Maybe<Scalars['String']>;
    success?: Maybe<Scalars['String']>;
};

/**
 * This contains the search results listings
 * - regular - just normal search results
 * - extended -if you get more than zero but less than ten results from your search and haven't specified an explicit radius, it'll try to expand the radius until it gets up to 25 extra results
 * - featured - a Float of listings that should be displayed as featured on the LSRP page
 */
export type Listings = {
    __typename?: 'Listings';
    /** If you get more than zero but less than ten results from your search and haven't specified an explicit radius, it'll try to expand the radius until it gets up to 25 extra results */
    extended?: Maybe<Array<Maybe<Listing>>>;
    /** Featured listing are specifically styled as a paid for listing advertisement */
    featured?: Maybe<Array<Maybe<Listing>>>;
    /** Regular is a normal search result */
    regular?: Maybe<Array<Maybe<Listing>>>;
};

/** Info about the development's listings */
export type ListingsDetails = {
    __typename?: 'ListingsDetails';
    /** Metadata - across resolvers */
    metaData?: Maybe<MetaData>;
    /** List of prices available on listings (non-repeated) */
    filterByPrice?: Maybe<Array<Maybe<Scalars['Float']>>>;
    /** List of beds available on listings (non-repeated) */
    filterByBeds?: Maybe<Array<Maybe<Scalars['Int']>>>;
    /** True if all listings are POA */
    hasOnlyPriceOnAsk?: Maybe<Scalars['Boolean']>;
    /** Listings Data */
    listings?: Maybe<Array<Maybe<NewHomesListing>>>;
};

export type LiveListing = {
    __typename?: 'LiveListing';
    branchName: Scalars['String'];
    displayAddress?: Maybe<Scalars['String']>;
    listingId: Scalars['String'];
    price?: Maybe<Scalars['Int']>;
    rentPerMonth?: Maybe<Scalars['Int']>;
    totalBedrooms?: Maybe<Scalars['Int']>;
    transactionType: Scalars['String'];
    uri: Scalars['String'];
};

export type LocationCoordinates = {
    __typename?: 'LocationCoordinates';
    latitude?: Maybe<Scalars['Float']>;
    longitude?: Maybe<Scalars['Float']>;
};

/** The response object for the marketActivity Query */
export type MarketActivityStats = {
    __typename?: 'MarketActivityStats';
    data?: Maybe<MarketActivityStatsData>;
    error?: Maybe<Array<Maybe<MarketActivityStatsErrorMessage>>>;
};

/** The success object for the marketActivity Query */
export type MarketActivityStatsData = {
    __typename?: 'MarketActivityStatsData';
    averagePricePaid?: Maybe<Scalars['Int']>;
    propertiesSold?: Maybe<Scalars['Int']>;
};

/** An error object */
export type MarketActivityStatsErrorMessage = {
    __typename?: 'MarketActivityStatsErrorMessage';
    /** A string describing the error type */
    code?: Maybe<Scalars['String']>;
    /** To describe the error */
    message: Scalars['String'];
    /** If relevant, some more info describing where the error has come from */
    path?: Maybe<Scalars['String']>;
};

/** Time range for market activity, relative to today, */
export enum MarketActivityWindow {
    All = 'ALL',
    FiveYears = 'FIVE_YEARS',
    SixMonths = 'SIX_MONTHS',
    TenYears = 'TEN_YEARS',
    ThreeMonths = 'THREE_MONTHS',
    TwelveMonths = 'TWELVE_MONTHS',
    TwentyYears = 'TWENTY_YEARS'
}

/** Market Statistic object can either be a successful result or an error. */
export type MarketStats = MarketStatsResults | MarketStatsError;

/** Input criteria for our Market Statistic results */
export type MarketStatsCriteria = {
    /** The Property type we want to match from our statistics */
    propertyType: Scalars['String'];
    /** The postal code we want to match from our statistics */
    postalCode: Scalars['String'];
    /** The optional amount of bedrooms that we want to match against in our statistics */
    bedrooms?: Maybe<Scalars['Int']>;
};

/**
 * Market Statistics error entity. The `errorCode` provides a simple identifier
 * to the frontend to handle error propertly
 */
export type MarketStatsError = {
    __typename?: 'MarketStatsError';
    /** The Enum providing minimal information on what happened in the backend */
    errorCode?: Maybe<MarketStatsErrorCode>;
};

/**
 * General error codes that can be returned to the frontend for better control
 * of component outputs.
 */
export enum MarketStatsErrorCode {
    BadRequest = 'BAD_REQUEST',
    PropertyNotFound = 'PROPERTY_NOT_FOUND',
    PostcodeNotFound = 'POSTCODE_NOT_FOUND',
    InvalidPropertyType = 'INVALID_PROPERTY_TYPE',
    ApplicationError = 'APPLICATION_ERROR',
    RequestTimeout = 'REQUEST_TIMEOUT',
    UnknownError = 'UNKNOWN_ERROR'
}

export type MarketStatsResults = {
    __typename?: 'MarketStatsResults';
    areaName?: Maybe<Scalars['String']>;
    areaNameUri?: Maybe<Scalars['String']>;
    askingPrices?: Maybe<AskingPrices>;
    propertyTypeGroup?: Maybe<PropertyTypeGroup>;
    historicalEstimates?: Maybe<Array<Maybe<HistoricalEstimate>>>;
    sales?: Maybe<Array<Maybe<HistoricalSales>>>;
    recentSales?: Maybe<Array<RecentSale>>;
};

/** Marketing details */
export type MarketingDetails = {
    __typename?: 'MarketingDetails';
    /** Metadata - across resolvers */
    metaData?: Maybe<MetaData>;
    address?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    openHours?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Media = {
    __typename?: 'Media';
    caption?: Maybe<Scalars['String']>;
    mimeType?: Maybe<Scalars['String']>;
    originalMimeType?: Maybe<Scalars['String']>;
    original?: Maybe<Scalars['String']>;
    url?: Maybe<Scalars['String']>;
    filename?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
};

export type MediaContent = {
    __typename?: 'MediaContent';
    floorPlan?: Maybe<Array<Media>>;
    virtualTour?: Maybe<Array<Media>>;
    audioTour?: Maybe<Array<Media>>;
};

export type MediaOrAdditionalLink = Media | AdditionalLink;

/** Data object defining meet the team content model. */
export type MeetTheTeam = {
    __typename?: 'MeetTheTeam';
    authors: Authors;
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    metaDescription: Scalars['String'];
    slug: Scalars['String'];
    title: Scalars['String'];
};

/** Data object defining meet the team content model. */
export type MeetTheTeamAuthorsArgs = {
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

/** Meet the team object error status enumerations. */
export enum MeetTheTeamErrorStatusCode {
    EntryNotFound = 'entry_not_found'
}

/** Data object defining meet the team error statuses. */
export type MeetTheTeamInvalidInputError = {
    __typename?: 'MeetTheTeamInvalidInputError';
    errorCode: MeetTheTeamErrorStatusCode;
};

/** Union type for fetching meet the team objects and potential error statuses. */
export type MeetTheTeamResult = MeetTheTeam | MeetTheTeamInvalidInputError;

export enum MemberType {
    Agent = 'agent',
    Developer = 'developer'
}

/** Data associated with a query for ONLY page meta data */
export type Meta = {
    __typename?: 'Meta';
    /** Title */
    title?: Maybe<Scalars['String']>;
    /** Description */
    description?: Maybe<Scalars['String']>;
    /** Keywords */
    keywords?: Maybe<Scalars['String']>;
    /** Robots */
    robots?: Maybe<Scalars['String']>;
    /** Canonical URI */
    canonicalUri?: Maybe<Scalars['String']>;
};

/** Meta data - Used to pass data cross resolvers without pollute other types context */
export type MetaData = {
    __typename?: 'MetaData';
    /** Old branch id to find a New Development data */
    deprecatedBranchId: Scalars['Int'];
    /** More detailed GEO infos */
    geoDescription?: Maybe<Scalars['String']>;
    /** Known as area_name coming from GEO API */
    geoName?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoCountyAreaName?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoPostTownName?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoRegionName?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoOutcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Supposed to be the new ID to find New Developments data and replace branch id */
    id: Scalars['Int'];
    /** Used for optimizely flag */
    useElasticSearch?: Maybe<Scalars['Boolean']>;
    /** Filters for New Developments Search */
    input?: Maybe<NewHomesDevelopmentSearchInputCopy>;
    /** Pagination navigation */
    first?: Maybe<Scalars['Int']>;
    /** Pagination navigation */
    last?: Maybe<Scalars['Int']>;
    /** Pagination cursor */
    after?: Maybe<Scalars['ID']>;
    /** Pagination cursor */
    before?: Maybe<Scalars['ID']>;
    /** Is the current query an extended results query? */
    isExtendedResultsQuery?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
    __typename?: 'Mutation';
    addConsent?: Maybe<Scalars['Boolean']>;
    deleteTrackedProperty?: Maybe<Scalars['Boolean']>;
    saveFavouriteListing?: Maybe<Scalars['Boolean']>;
    deleteFavouriteListing?: Maybe<Scalars['Boolean']>;
    saveFavouriteProperty?: Maybe<Scalars['Boolean']>;
    deleteFavouriteProperty?: Maybe<Scalars['Boolean']>;
    saveTrackedProperty?: Maybe<Scalars['Boolean']>;
    /**
     * Registers a user. Automatically logs them in if the session id
     * and persistent session id are in the cookie.
     */
    registerUser?: Maybe<RegisterUserPayload>;
    signinUser?: Maybe<SigninUserPayload>;
    contactAgents?: Maybe<EmailAllSubmission>;
    sendContactAgentLead?: Maybe<NewHomesLeadResponse>;
    sendArrangeViewingLead?: Maybe<NewHomesLeadResponse>;
    updateSavedSearch?: Maybe<SimpleResponse>;
    createNewSavedSearch?: Maybe<SimpleResponse>;
    createNewEmailAlert?: Maybe<SimpleResponse>;
    socialSignInGoogle?: Maybe<SocialSignInGoogleResponse>;
    socialSignInGoogleOneTap?: Maybe<SocialSignInGoogleOneTapResponse>;
    socialSignInFacebook?: Maybe<SocialSignInFacebookResponse>;
    socialSignInApple?: Maybe<SocialSignInAppleResponse>;
    updateUserConsents?: Maybe<Scalars['Boolean']>;
    updateUserEmailPreferences?: Maybe<Scalars['Boolean']>;
    /** Unsubscribe a user from permission. Deletes the user's permission based on an unsubscribe id */
    unsubscribeUserPermission?: Maybe<Permission>;
    deleteTrackedPropertyPermissions?: Maybe<Scalars['Boolean']>;
    updateUserAboutMe?: Maybe<Scalars['Boolean']>;
    createValuationLead: ValuationLeadResponse;
    createEmailLead: EmailLeadResponse;
    saveUserListing: SavedListingUpdateResult;
    deleteUserListings: SavedListingUpdateResult;
    createDynamicAgentPhone: DynamicAgentPhone;
    createZooplaValuationToolValuation?: Maybe<ZvtFormSubmissionValuationResponse>;
    validateZooplaValuationToolEmail?: Maybe<ZvtValidateEmailResponse>;
    createSavedSearch?: Maybe<SavedSearch>;
    deleteSavedSearch?: Maybe<Scalars['Boolean']>;
    addAlertToSavedSearch?: Maybe<SavedSearchAlert>;
    editSavedSearchAlert?: Maybe<Scalars['Boolean']>;
};

export type MutationAddConsentArgs = {
    input: ConsentAgreementInput;
};

export type MutationDeleteTrackedPropertyArgs = {
    propertyId?: Maybe<Scalars['String']>;
    uprn?: Maybe<Scalars['String']>;
};

export type MutationSaveFavouriteListingArgs = {
    id: Scalars['ID'];
};

export type MutationDeleteFavouriteListingArgs = {
    id: Scalars['ID'];
};

export type MutationSaveFavouritePropertyArgs = {
    id: Scalars['ID'];
};

export type MutationDeleteFavouritePropertyArgs = {
    id: Scalars['ID'];
};

export type MutationSaveTrackedPropertyArgs = {
    trackedProperty: TrackedPropertyInput;
};

export type MutationRegisterUserArgs = {
    input: RegisterUserInput;
};

export type MutationSigninUserArgs = {
    input: SigninUserInput;
};

export type MutationContactAgentsArgs = {
    input: EmailAllDetails;
};

export type MutationSendContactAgentLeadArgs = {
    input: NewHomesLeadInput;
};

export type MutationSendArrangeViewingLeadArgs = {
    input: NewHomesLeadInput;
};

export type MutationUpdateSavedSearchArgs = {
    input: SearchFields;
};

export type MutationCreateNewSavedSearchArgs = {
    input: SearchFields;
};

export type MutationCreateNewEmailAlertArgs = {
    input: SearchFields;
};

export type MutationSocialSignInGoogleArgs = {
    accessToken: Scalars['String'];
};

export type MutationSocialSignInGoogleOneTapArgs = {
    accessToken: Scalars['String'];
};

export type MutationSocialSignInFacebookArgs = {
    accessToken: Scalars['String'];
};

export type MutationSocialSignInAppleArgs = {
    input: SocialSignInAppleInput;
};

export type MutationUpdateUserConsentsArgs = {
    input: UpdateUserConsentsInput;
};

export type MutationUpdateUserEmailPreferencesArgs = {
    input: EmailPreferencesInput;
};

export type MutationUnsubscribeUserPermissionArgs = {
    input: UnsubscribeUserPermissionInput;
};

export type MutationDeleteTrackedPropertyPermissionsArgs = {
    uprn: Scalars['String'];
};

export type MutationUpdateUserAboutMeArgs = {
    input: UserAboutMeInput;
};

export type MutationCreateValuationLeadArgs = {
    lead: ValuationLeadInput;
};

export type MutationCreateEmailLeadArgs = {
    id: Scalars['Int'];
    lead: EmailLeadInput;
};

export type MutationSaveUserListingArgs = {
    listingId: Scalars['Int'];
};

export type MutationDeleteUserListingsArgs = {
    listingIds: Array<Scalars['Int']>;
};

export type MutationCreateDynamicAgentPhoneArgs = {
    input: DynamicAgentPhoneInput;
};

export type MutationCreateZooplaValuationToolValuationArgs = {
    input: ZvtFormSubmissionValuationInput;
};

export type MutationValidateZooplaValuationToolEmailArgs = {
    input: ZvtValidateEmailInput;
};

export type MutationCreateSavedSearchArgs = {
    input: SavedSearchInput;
};

export type MutationDeleteSavedSearchArgs = {
    input: DeleteSavedSearchInput;
};

export type MutationAddAlertToSavedSearchArgs = {
    savedSearchId: Scalars['ID'];
    input: SavedSearchAlertInput;
};

export type MutationEditSavedSearchAlertArgs = {
    alertId: Scalars['ID'];
    input: EditSavedSearchAlertInput;
};

export type Navbar = {
    __typename?: 'Navbar';
    id: Scalars['ID'];
    name?: Maybe<Scalars['String']>;
    items?: Maybe<Array<Maybe<Item>>>;
};

/** New homes development data */
export type NewHomesDevelopmentData = {
    __typename?: 'NewHomesDevelopmentData';
    /** Metadata - across resolvers */
    metaData?: Maybe<MetaData>;
    name?: Maybe<Scalars['String']>;
    logoUri?: Maybe<Scalars['String']>;
    listingsCount?: Maybe<Scalars['Int']>;
    /** Number of bedrooms */
    bedrooms?: Maybe<Scalars['String']>;
    helpToBuy?: Maybe<Scalars['Boolean']>;
    sharedOwnership?: Maybe<Scalars['Boolean']>;
    hasFlats?: Maybe<Scalars['Boolean']>;
    hasHouses?: Maybe<Scalars['Boolean']>;
    retirement?: Maybe<Scalars['Boolean']>;
    description?: Maybe<Scalars['String']>;
    /** Minimum Development Price */
    minimumPlotPrice?: Maybe<Scalars['Float']>;
    minPrice?: Maybe<Scalars['Float']>;
    maxPrice?: Maybe<Scalars['Float']>;
    images?: Maybe<Array<Maybe<Scalars['String']>>>;
    address?: Maybe<Scalars['String']>;
    town?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    /** Used in URL generation */
    seoBranchName?: Maybe<Scalars['String']>;
    developer?: Maybe<Developer>;
    /** Coordinates - lat */
    latitude?: Maybe<Scalars['Float']>;
    /** Coordinates - long */
    longitude?: Maybe<Scalars['Float']>;
    /** Points Of Interest eg: stations and schools */
    pointsOfInterest?: Maybe<Array<Maybe<PointOfInterest>>>;
    marketingDetails?: Maybe<MarketingDetails>;
    analyticsTracking?: Maybe<AnalyticsTracking>;
    extendedDevelopmentData?: Maybe<ExtendedDevelopmentData>;
    listingsDetails?: Maybe<ListingsDetails>;
};

/**
 * A Connection as defined by the Relay pagination docs.
 * comprises a set of edges and some info about what is available next
 * in terms of pagination
 */
export type NewHomesDevelopmentSearchConnection = {
    __typename?: 'NewHomesDevelopmentSearchConnection';
    /**
     * Edges can be any array of data in a certain shape, but in this instance
     * they are a set of edges built by the response of Elatic Search developments data
     */
    edges?: Maybe<Array<Maybe<NewHomesDevelopmentSearchEdge>>>;
    /** Page info about what is available for paginating. */
    pageInfo: PageInfo;
};

/** An Edge as defined by the Relay pagination docs. */
export type NewHomesDevelopmentSearchEdge = {
    __typename?: 'NewHomesDevelopmentSearchEdge';
    /**
     * Normally an id identifying where the user currently is in terms of
     * what page they're on
     */
    cursor?: Maybe<Scalars['String']>;
    /**
     * A node can be any piece of data. in this instance it is always a development
     * as returned from Elastic Search (developments data)
     */
    node?: Maybe<NewHomesDevelopmentData>;
};

/** Filter parameters for search */
export type NewHomesDevelopmentSearchInput = {
    /**
     * Developments to be excluded from the extended results search
     * because they were part of the reular results
     */
    filteredIds?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Identifier returned by GEO API */
    geoIdentifier?: Maybe<Scalars['String']>;
    /** If no Identifier found a search can use search input value typed */
    geoString?: Maybe<Scalars['String']>;
    /** Filter by max beds */
    maxBeds?: Maybe<Scalars['Int']>;
    /** Filter by max price */
    maxPrice?: Maybe<Scalars['Float']>;
    /** Filter by min beds */
    minBeds?: Maybe<Scalars['Int']>;
    /** Filter by min price */
    minPrice?: Maybe<Scalars['Float']>;
    /** Filter by property type ("houses" or "flats") */
    propertyType?: Maybe<Array<Maybe<PropertyTypeFilter>>>;
    /** Filter by GEO radius distance. When not used default to 25 miles and 40 miles on extended results */
    radius?: Maybe<Scalars['String']>;
};

/** Copy of NewHomesDevelopmentSearchInput since it cannot be reused */
export type NewHomesDevelopmentSearchInputCopy = {
    __typename?: 'NewHomesDevelopmentSearchInputCopy';
    /**
     * Developments to be excluded from the extended results search
     * because they were part of the reular results
     */
    filteredIds?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Identifier returned by GEO API */
    geoIdentifier?: Maybe<Scalars['String']>;
    /** If no Identifier found a search can use search input value typed */
    geoString?: Maybe<Scalars['String']>;
    /** Filter by max beds */
    maxBeds?: Maybe<Scalars['Int']>;
    /** Filter by max price */
    maxPrice?: Maybe<Scalars['Float']>;
    /** Filter by min beds */
    minBeds?: Maybe<Scalars['Int']>;
    /** Filter by min price */
    minPrice?: Maybe<Scalars['Float']>;
    /** Filter by property type ("houses" or "flats") */
    propertyType?: Maybe<Array<Maybe<PropertyTypeFilter>>>;
    /** Filter by GEO radius distance. When not used default to 25 miles and 40 miles on extended results */
    radius?: Maybe<Scalars['String']>;
};

/** New Homes developments search result details */
export type NewHomesDevelopmentSearchResultDetails = {
    __typename?: 'NewHomesDevelopmentSearchResultDetails';
    /** Total results */
    totalResults?: Maybe<Scalars['Int']>;
    /** Connection for pagination */
    data?: Maybe<NewHomesDevelopmentSearchConnection>;
};

/** New Homes developments search results */
export type NewHomesDevelopmentSearchResults = {
    __typename?: 'NewHomesDevelopmentSearchResults';
    /** Metadata - across resolvers */
    metaData?: Maybe<MetaData>;
    /** List of all developments, regular and extended, found on search */
    searchResults?: Maybe<NewHomesDevelopmentSearchResultsItems>;
};

/** The actual search result items of a NewHomesDevelopmentSearchResults */
export type NewHomesDevelopmentSearchResultsItems = {
    __typename?: 'NewHomesDevelopmentSearchResultsItems';
    /** List of extended developments with a wider distance range */
    extendedResults?: Maybe<NewHomesDevelopmentSearchResultDetails>;
    /** List of developments found on search */
    results?: Maybe<NewHomesDevelopmentSearchResultDetails>;
};

/** Lead Form - Message model */
export type NewHomesLeadInput = {
    /** Info about the user */
    aboutMe?: Maybe<Scalars['String']>;
    /** The best time for the agent to call the user */
    bestTimeToCall?: Maybe<BestTimeToCallType>;
    /** The unique branch ID for the development being enquired about */
    branchId?: Maybe<Scalars['String']>;
    /** The user's email address */
    email?: Maybe<Scalars['String']>;
    /** Whether the user is looking to move */
    lookingToMove?: Maybe<Scalars['String']>;
    /** Marketing opt-in */
    marketingOptIn?: Maybe<Scalars['Boolean']>;
    /** The message to be sent */
    message?: Maybe<Scalars['String']>;
    /** The user's name */
    name?: Maybe<Scalars['String']>;
    /** The user's phone number */
    phone?: Maybe<Scalars['String']>;
    /** The type of enquiry */
    typeOfEnquiry?: Maybe<EnquiryType>;
};

/** Response from successful message sent */
export type NewHomesLeadResponse = {
    __typename?: 'NewHomesLeadResponse';
    /** True/False for form submission */
    success?: Maybe<Scalars['Boolean']>;
    /** ID of the form submission */
    uniqueLeadIdentifier?: Maybe<Scalars['String']>;
};

/** Individual listing data */
export type NewHomesListing = IListing & {
    __typename?: 'NewHomesListing';
    /** True if balcony available */
    balcony?: Maybe<Scalars['Boolean']>;
    /** Overriden IListing counts by new homes resolver */
    counts: RoomCount;
    /** Overriden IListing floorArea by new homes resolver */
    floorArea?: Maybe<FloorArea>;
    /** True if garage available */
    garage?: Maybe<Scalars['Boolean']>;
    /** True if garden available */
    garden?: Maybe<Scalars['Boolean']>;
    /** Whether the Help to Buy scheme is available */
    helpToBuy?: Maybe<Scalars['Boolean']>;
    /** True if POA */
    isPriceOnAsk?: Maybe<Scalars['Boolean']>;
    listingId: Scalars['ID'];
    /** True if parking available */
    parking?: Maybe<Scalars['Boolean']>;
    /** Overriden IListing pricing by new homes resolver */
    pricing: ListingPricing;
    /** IListing propertyType */
    propertyType?: Maybe<Scalars['String']>;
    /** True if retirement property */
    retirement?: Maybe<Scalars['Boolean']>;
    /** IListing section */
    section?: Maybe<Scalars['String']>;
    /** Whether the Shared Ownership scheme is available */
    sharedOwnership?: Maybe<Scalars['Boolean']>;
    /** True if terrace available */
    terrace?: Maybe<Scalars['Boolean']>;
};

/** Data object defining News and Guides content model. */
export type NewsAndGuides = {
    __typename?: 'NewsAndGuides';
    categories: Array<Maybe<ArticleCategory>>;
    description?: Maybe<Scalars['String']>;
    metaDescription: Scalars['String'];
    slug: Scalars['String'];
    title: Scalars['String'];
};

/** Union type for fetching News and Guides objects and potential error statuses. */
export type NewsAndGuidesResult = NewsAndGuides | CmsError;

export type PageInfo = {
    __typename?: 'PageInfo';
    hasPreviousPage: Scalars['Boolean'];
    hasNextPage: Scalars['Boolean'];
    startCursor: Scalars['ID'];
    endCursor: Scalars['ID'];
};

/** Data associated with a query for ONLY listings pagination */
export type Pagination = {
    __typename?: 'Pagination';
    /** Url of next page of listings */
    nextPageUri?: Maybe<Scalars['String']>;
    /** Last page number */
    pageEndIndex?: Maybe<Scalars['Int']>;
    /** Current page number */
    pageNumber?: Maybe<Scalars['Int']>;
    /** Last page number */
    pageNumberMax?: Maybe<Scalars['Int']>;
    /** First page number */
    pageStartIndex?: Maybe<Scalars['Int']>;
    /** Total number of search results */
    totalResults?: Maybe<Scalars['Int']>;
    /** Flag indicating if search results was limited */
    totalResultsWasLimited?: Maybe<Scalars['Boolean']>;
};

export type PastSuggestedAddresses = {
    __typename?: 'PastSuggestedAddresses';
    v?: Maybe<Scalars['String']>;
};

/** Arguments to get a url path for listings search by parameters */
export type PathByParamFields = {
    filters: PathByParamSearchFields;
    searchSource: Scalars['String'];
    sortOrder?: Maybe<Scalars['String']>;
    userAlertId?: Maybe<Scalars['String']>;
    excludeRadius?: Maybe<Scalars['Boolean']>;
    page?: Maybe<Scalars['Int']>;
};

export type PathByParamSearchFields = {
    description?: Maybe<Scalars['String']>;
    userAlertId?: Maybe<Scalars['String']>;
    /** Location info. Can be passed in as a geoSuggestions */
    location: SearchParamLocation;
    /** section is basically a search type. Normally for-sale or to-rent. */
    section: Scalars['String'];
    category?: Maybe<Scalars['String']>;
    priceFrequency?: Maybe<Scalars['String']>;
    /** Whether to include shared accomodation in rental searches. */
    includeSharedAccommodation?: Maybe<Scalars['Boolean']>;
    /** To search for rental properties that allow pets. */
    petsAllowed?: Maybe<Scalars['Boolean']>;
    /**
     * To include already rental properties in a rental search.
     * Sometimes shown as "Let or Let agreed"
     */
    includeRented?: Maybe<Scalars['Boolean']>;
    /** To include bills in the payments for your rental search. */
    billsIncluded?: Maybe<Scalars['Boolean']>;
    /** Whether to include shared ownership properties in for sale searches. */
    includeSharedOwnership?: Maybe<Scalars['Boolean']>;
    /**
     * Whether to include already sold or 'Sold Subject To Contract'
     * properties in for sale searches.
     */
    includeSold?: Maybe<Scalars['Boolean']>;
    /** Whether to include properties at auction in for sale searches. */
    isAuction?: Maybe<Scalars['Boolean']>;
    /** Whether to include retirement homes in for sale searches. */
    includeRetirementHomes?: Maybe<Scalars['Boolean']>;
    /** words such as 'Garden' or 'wooden floor' passed in as free text from the client. */
    keywords?: Maybe<Scalars['String']>;
    /**
     * Equivalent to the 'geoIdentifier' normally used in the url path
     * such as 'london-fields'
     */
    identifier?: Maybe<Scalars['String']>;
    /**
     * Number string e.g. '0.5' or '1' representing the amount of miles always
     * from the location selected to capture in the search.
     */
    radius?: Maybe<Scalars['String']>;
    /**
     * The date the property was added, can be:
     * '' (anytime), '24_hours', '3_days', '7_days', '14_days', '30_days'
     */
    added?: Maybe<Scalars['String']>;
    availableFrom?: Maybe<Scalars['String']>;
    /** Minimum price of a property (for-sale) */
    priceMin?: Maybe<Scalars['String']>;
    /** Maximum price of a property (for-sale) */
    priceMax?: Maybe<Scalars['String']>;
    /** Minimum amount of beds in the property */
    bedsMin?: Maybe<Scalars['String']>;
    /** Maximum amount of beds in the property */
    bedsMax?: Maybe<Scalars['String']>;
    rentalTerm?: Maybe<Scalars['String']>;
    furnishedState?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    propertySubType?: Maybe<Array<Maybe<Scalars['String']>>>;
    feature?: Maybe<Array<Maybe<Scalars['String']>>>;
    buyerIncentive?: Maybe<Scalars['String']>;
    newHomes?: Maybe<Scalars['String']>;
    chainFree?: Maybe<Scalars['String']>;
    reducedPriceOnly?: Maybe<Scalars['String']>;
    viewType?: Maybe<Scalars['String']>;
    polyenc?: Maybe<Scalars['String']>;
    /** Below fields are unused */
    isRetirementHome?: Maybe<Scalars['String']>;
};

export type PerlNavigationData = {
    __typename?: 'PerlNavigationData';
    accordions?: Maybe<Array<Maybe<SeoAccordions>>>;
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumbs>>>;
    discoverMore?: Maybe<DiscoverMore>;
    backToResultsLink?: Maybe<BackToResultsLink>;
};

/** The permission that has been granted */
export type Permission = {
    __typename?: 'Permission';
    /** The entity that permission is set for (UPRN) */
    entityId?: Maybe<Scalars['String']>;
    /** The ID of the permission */
    permissionId?: Maybe<Scalars['String']>;
    /** The permission type that has been granted */
    permissionType?: Maybe<Scalars['String']>;
};

/** The permissions that have been granted */
export type Permissions = {
    __typename?: 'Permissions';
    /** Whether or not any permissions have been granted */
    hasPermissions?: Maybe<Scalars['Boolean']>;
    /** All the ids of the granted Permissions */
    ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PointOfInterest = {
    __typename?: 'PointOfInterest';
    title?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    distanceMiles?: Maybe<Scalars['Float']>;
    latitude?: Maybe<Scalars['Float']>;
    longitude?: Maybe<Scalars['Float']>;
    address?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY listings polygons */
export type Polygon = {
    __typename?: 'Polygon';
    /** Ancillary polygon data  */
    geoData?: Maybe<GeoData>;
    /** The type of geo area that has been selected by the GEO API for the given input. */
    geoType?: Maybe<Scalars['String']>;
    /** Coordinates of the polygon for area selected by the GEO API */
    polygons?: Maybe<
        Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Float']>>>>>>
    >;
    /** The number of miles the initial searched term has been extended by.  */
    radius?: Maybe<Scalars['Float']>;
};

/** possible email consents */
export type PossibleEmailConsent = {
    __typename?: 'PossibleEmailConsent';
    consentId?: Maybe<Scalars['Int']>;
    key?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
};

/** Data associated with a query for Sort Price Drop */
export type PriceDrop = {
    __typename?: 'PriceDrop';
    /** The date the associated Listing's price changed */
    lastPriceChangeDate?: Maybe<Scalars['String']>;
    /** The percentage that the Property's value last changed   */
    percentageChangeLabel?: Maybe<Scalars['String']>;
};

export type PriceHistory = {
    __typename?: 'PriceHistory';
    firstPublished?: Maybe<PriceHistoryFirstPublished>;
    lastSale?: Maybe<PriceHistoryLastSale>;
    priceChanges?: Maybe<Array<PriceHistoryChange>>;
};

export type PriceHistoryChange = {
    __typename?: 'PriceHistoryChange';
    isMinorChange: Scalars['Boolean'];
    isPriceDrop: Scalars['Boolean'];
    isPriceIncrease: Scalars['Boolean'];
    percentageChangeLabel: Scalars['String'];
    priceChangeDate: Scalars['String'];
    priceChangeLabel: Scalars['String'];
    priceLabel: Scalars['String'];
};

export type PriceHistoryFirstPublished = {
    __typename?: 'PriceHistoryFirstPublished';
    firstPublishedDate?: Maybe<Scalars['String']>;
    priceLabel?: Maybe<Scalars['String']>;
};

export type PriceHistoryLastSale = {
    __typename?: 'PriceHistoryLastSale';
    date: Scalars['String'];
    newBuild: Scalars['Boolean'];
    price: Scalars['Float'];
    priceLabel: Scalars['String'];
    recentlySold: Scalars['Boolean'];
};

/** Information data containing display data and internal value representing a given price */
export type PriceInfo = {
    __typename?: 'PriceInfo';
    currencyCode?: Maybe<Scalars['String']>;
    internalValue: Scalars['Float'];
    label?: Maybe<Scalars['String']>;
    rentFrequencyLabel?: Maybe<Scalars['String']>;
    unitsLabel?: Maybe<Scalars['String']>;
    valueLabel?: Maybe<Scalars['String']>;
};

export type Properties = {
    __typename?: 'Properties';
    fullAddress?: Maybe<Scalars['String']>;
    propertyId: Scalars['Int'];
};

/**
 * A Connection as defined by the Relay pagination docs.
 * comprises a set of edges and some info about what is available next
 * in terms of pagination
 */
export type PropertiesSearchConnection = {
    __typename?: 'PropertiesSearchConnection';
    /**
     * Edges can be any array of data in a certain shape, but in this instance
     * they are a set of edges built by the response of the api-properties-search
     */
    edges?: Maybe<Array<Maybe<PropertiesSearchEdge>>>;
    /**
     * Flag to specify whether totalResults are accurate or approximate
     * @deprecated No longer needed since we now have accurate total results every time
     */
    isTotalResultsAccurate?: Maybe<Scalars['Boolean']>;
    /** Metadata - across resolvers */
    metaData?: Maybe<PropertiesSearchMetaData>;
    /** Total number of pages from pagination data. */
    pageCount?: Maybe<Scalars['Int']>;
    /** Page info about what is available for paginating. */
    pageInfo: PageInfo;
    /** Total results based of pagination data. */
    totalResults?: Maybe<Scalars['Int']>;
};

/** An Edge as defined by the Relay pagination docs. */
export type PropertiesSearchEdge = {
    __typename?: 'PropertiesSearchEdge';
    /**
     * Normally an id identifying where the user currently is in terms of
     * what page they're on
     */
    cursor?: Maybe<Scalars['ID']>;
    /**
     * A node can be any piece of data. in this instance it is always a property
     * as returned from api-property-search
     */
    node?: Maybe<Property>;
};

/** An error object */
export type PropertiesSearchErrorMessage = {
    __typename?: 'PropertiesSearchErrorMessage';
    /** A string describing the error type */
    code?: Maybe<Scalars['String']>;
    /** To describe the error */
    message: Scalars['String'];
    /** If relevant, some more info describing where the error has come from */
    path?: Maybe<Scalars['String']>;
};

/** Meta data - Used to pass data cross resolvers without pollute other types context */
export type PropertiesSearchMetaData = {
    __typename?: 'PropertiesSearchMetaData';
    /** Used in page info tracking */
    geoAlias?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoCountyAreaName?: Maybe<Scalars['String']>;
    /** More detailed GEO infos */
    geoDescription?: Maybe<Scalars['String']>;
    /** Used in page tracking info */
    geoIncode?: Maybe<Scalars['String']>;
    /** Known as area_name coming from GEO API */
    geoName?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoOutcode?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoOutcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Used in page info tracking */
    geoPostTownName?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoPostalArea?: Maybe<Scalars['String']>;
    /** Used in page info tracking */
    geoRegionName?: Maybe<Scalars['String']>;
    /** Contains data about the request */
    input?: Maybe<PropertiesSearchMetaInput>;
};

/** Copy of certain input params */
export type PropertiesSearchMetaInput = {
    __typename?: 'PropertiesSearchMetaInput';
    /** Identifier returned by GEO API */
    geoIdentifier?: Maybe<Scalars['String']>;
    /** If no Identifier found a search can use search input value typed */
    geoString?: Maybe<Scalars['String']>;
};

/**
 * The potential responses from the property search resolver
 * Basically will return a paginated connection, or an error
 */
export type PropertiesSearchResponse =
    | PropertiesSearchConnection
    | PropertiesSearchResponseError;

/** The error that can be returned from the property search resolver */
export type PropertiesSearchResponseError = {
    __typename?: 'PropertiesSearchResponseError';
    /** Array of property search errors */
    errors?: Maybe<Array<Maybe<PropertiesSearchErrorMessage>>>;
};

/**
 * A physical place in the real world we know about.
 * We might have house-price estimates and other data about it.
 * Powers the property details page.
 */
export type Property = {
    __typename?: 'Property';
    /**
     * Zoopla-internal property identifier.
     * Existing queries may return this, but in the future not every property will have one.
     * @deprecated Prefer uprn. Added to support migration to UPRN-first properties.
     */
    propertyId?: Maybe<Scalars['ID']>;
    /**
     * Universal Property Reference Number.
     * Public sector standard for referencing property information.
     * Nullable until we're fully migrated.
     * See https://en.wikipedia.org/wiki/Unique_Property_Reference_Number
     */
    uprn?: Maybe<Scalars['ID']>;
    trackedProperty?: Maybe<TrackedProperty>;
    pointsOfInterest?: Maybe<Array<Maybe<PointOfInterest>>>;
    liveListings?: Maybe<Array<LiveListing>>;
    similarListings?: Maybe<Array<Maybe<Listing>>>;
    similarProperties?: Maybe<Array<Property>>;
    /** @deprecated Please use history.historicSales */
    lastSale?: Maybe<LastSaleData>;
    attributes?: Maybe<Attributes>;
    address?: Maybe<Address>;
    saleEstimate?: Maybe<SaleEstimate>;
    rentEstimate?: Maybe<RentEstimate>;
    history?: Maybe<History>;
};

/**
 * A physical place in the real world we know about.
 * We might have house-price estimates and other data about it.
 * Powers the property details page.
 */
export type PropertyTrackedPropertyArgs = {
    id?: Maybe<Scalars['String']>;
    uprn?: Maybe<Scalars['String']>;
};

/**
 * A physical place in the real world we know about.
 * We might have house-price estimates and other data about it.
 * Powers the property details page.
 */
export type PropertyLiveListingsArgs = {
    id?: Maybe<Scalars['String']>;
    uprn?: Maybe<Scalars['String']>;
};

/**
 * A physical place in the real world we know about.
 * We might have house-price estimates and other data about it.
 * Powers the property details page.
 */
export type PropertySimilarListingsArgs = {
    id?: Maybe<Scalars['String']>;
    uprn?: Maybe<Scalars['String']>;
};

/** Property Last Sale object can either be a successful result or an error. */
export type PropertyLastSale = PropertyLastSaleResults | MarketStatsError;

export type PropertyLastSaleResults = {
    __typename?: 'PropertyLastSaleResults';
    date?: Maybe<Scalars['String']>;
    price?: Maybe<Scalars['Int']>;
    newBuild?: Maybe<Scalars['Boolean']>;
    recentlySold?: Maybe<Scalars['Boolean']>;
};

/**
 * Property search uses a geoIdentifier which is sourced from the geo API based on
 * the users search input.
 */
export type PropertySearchParams = {
    /** Filter results to those with a sale date more recently than the input */
    fromLastSaleDate?: Maybe<Scalars['String']>;
    /** A geo identifier which may look like something like: west-yorkshire/bradford/hoxton-street */
    geoIdentifier?: Maybe<Scalars['GeoIdentifier']>;
    /** A string for post code and free text searches */
    geoString?: Maybe<Scalars['String']>;
    /** Filter properties by their type code e.g. 'F' for flat */
    propertyTypeCode?: Maybe<Scalars['String']>;
    /** Direction to sort in e.g. asc or desc for ascending and descending respectively */
    sortDirection?: Maybe<Scalars['String']>;
    /** Sort order is the property which to sort on e.g. address */
    sortOrder?: Maybe<Scalars['String']>;
    /** Filter results to those with a sale date less recently than the input */
    toLastSaleDate?: Maybe<Scalars['String']>;
};

/** Property types supported by search filters */
export enum PropertyTypeFilter {
    Flat = 'FLAT',
    House = 'HOUSE'
}

export enum PropertyTypeGroup {
    Flat = 'flat',
    House = 'house'
}

/** Data object defining pros and cons content model. */
export type ProsAndConsDetails = {
    __typename?: 'ProsAndConsDetails';
    consDescription?: Maybe<RichText>;
    heading?: Maybe<Scalars['String']>;
    prosDescription?: Maybe<RichText>;
    subHeading?: Maybe<Scalars['String']>;
};

export enum PublicationStatus {
    Expired = 'Expired',
    Live = 'Live'
}

export type Query = {
    __typename?: 'Query';
    /** Gets the (legacy) split tests for a given persistent session */
    abTests?: Maybe<Array<AbTest>>;
    addressesByPostcode?: Maybe<AddressesByPostcode>;
    agentBranch?: Maybe<AgentBranch>;
    agentExclusions?: Maybe<AgentExclusions>;
    allNavBars?: Maybe<Array<Maybe<Navbar>>>;
    /**
     * Returns the name of a given area.
     * Null if there is no data available.
     */
    area?: Maybe<Area>;
    articleCategories?: Maybe<ArticleCategories>;
    /** Fetches a single category object or error object. */
    articleCategory?: Maybe<ArticleCategoryResult>;
    articleTag?: Maybe<ArticleTagResult>;
    /** Fetches a single article object or error object if article not found. */
    article?: Maybe<ArticleResult>;
    /** Fetches a single article collection object */
    articleCollection?: Maybe<ArticleCollectionResult>;
    articles?: Maybe<Articles>;
    author?: Maybe<AuthorResult>;
    authors?: Maybe<Authors>;
    userTrackedProperties?: Maybe<UserTrackedProperties>;
    backToResultsLink?: Maybe<BackToResultsLink>;
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumbs>>>;
    /** Fetches a single chapter object or error object. */
    chapter?: Maybe<ChapterResult>;
    cmsEntry?: Maybe<CmsEntry>;
    discoverMore?: Maybe<DiscoverMore>;
    /**
     * Echoes input given as a response
     * A simple query to test a new client, or the server without hitting a downstream datasource
     */
    echo: Scalars['String'];
    emailAll?: Maybe<EmailAll>;
    favourites?: Maybe<Favourites>;
    geoSuggestion?: Maybe<Array<Maybe<GeoSuggestion>>>;
    getSuggestedAddresses?: Maybe<AddressPostcodeSuggestion>;
    googleMapUrlSignatures?: Maybe<Array<Maybe<Scalars['String']>>>;
    govSchemes?: Maybe<GovSchemesData>;
    /** Fetches a single guide object or error object. */
    guide?: Maybe<GuideResult>;
    /** Fetches a single homepage object or error object. */
    homepage?: Maybe<HomepageResult>;
    /**
     * Fetches a single listing
     * @deprecated Use listingDetails - which returns a Union type to deal with errors gracefully
     */
    listing?: Maybe<ListingData>;
    /** Fetches multiple listings given a set of id's. */
    listings?: Maybe<BaseListingsResponse>;
    /**
     * Temporary switch to change the behaviour of error responses by stopping throwing error
     * and return a propery GraphQL error entity with an `errorCode`. Once app-react has switched to it
     * we will then "duplicate" the same behaviour on both `listing` and `listingDetails` and switch all
     * back to `listing` as its name is simple and describe precisely what entity we will get.
     */
    listingDetails?: Maybe<ListingDetails>;
    listingPreview?: Maybe<Listing>;
    /**
     * Returns the market activity for a given area.
     * Null if there is no data available for the given time period and/or house type.
     * Request multiple times if multiple types/time ranges are required.
     */
    marketActivity?: Maybe<MarketActivityStats>;
    /**
     * Retrieve market statistics based on a property type, a postal code and optionally
     * the amount of property bedrooms
     */
    marketStats?: Maybe<MarketStats>;
    meetTheTeam?: Maybe<MeetTheTeamResult>;
    navbar?: Maybe<Navbar>;
    /** Retrieve viewCount from ReportsAPI */
    viewCount?: Maybe<ViewCountData>;
    /** New Homes Development data for DDP */
    newHomesDevelopmentData?: Maybe<NewHomesDevelopmentData>;
    /** New Homes Search by developments */
    newHomesSearch?: Maybe<NewHomesDevelopmentSearchResults>;
    /** Fetches a single News and Guides object or error object. */
    newsAndGuides?: Maybe<NewsAndGuidesResult>;
    pointsOfInterest?: Maybe<Array<Maybe<PointOfInterest>>>;
    properties: Array<Properties>;
    property?: Maybe<Property>;
    /** Retrieve property last sale data from a property ID */
    propertyLastSale?: Maybe<PropertyLastSale>;
    redirects?: Maybe<Array<Maybe<Redirect>>>;
    /** Fetches a user's saved properties. Requires a session cookie */
    savedProperties: SavedProperties;
    searchResults?: Maybe<Results>;
    /** Fetches a list of results to display on a 'feed' e.g. LSRP */
    searchResultsV2?: Maybe<ResultsV2>;
    searchResultsByParams?: Maybe<Results>;
    seoAccordions?: Maybe<Array<Maybe<SeoAccordions>>>;
    /** Fetches a small print object or a small print not found error */
    smallPrint?: Maybe<SmallPrintResult>;
    trackedProperties?: Maybe<UserTrackedProperties>;
    user?: Maybe<User>;
    propertiesSearch: PropertiesSearchResponse;
    /** Fetch user's saved properties as small cursor objects */
    enrichedSavedPropertyIds: EnrichedSavedPropertyIdsResult;
    /**
     * A list of methods a user can use to login for a given email.
     * The user does not need to be logged in to call this query.
     */
    userLoginMethods?: Maybe<UserLoginMethodsResponse>;
    /**
     * Returns back the address details given a property ID by using the API
     * http://api-property-details.qa.zoopla.co.uk/api. This is a temporary Query for OVLO
     * until we migrate to support UPRNs.
     * @deprecated Temporary solution. Please use the property(...) query instead for other use cases
     */
    valuationAddress: ValuationAddress;
    /**
     * Valuation branch for a single branch ID.
     * Used by the /valuation page.
     * Throws a UserInputError if no branch is found for the given ID.
     */
    valuationBranch: ValuationBranch;
    /**
     * Valuation branches for a given property ID, transaction type and randomisation sort seed.
     * Used by the /valuation page.
     */
    valuationBranches: Array<ValuationBranch>;
    zooplaValuationToolData: ZooplaValuationToolData;
};

export type QueryAddressesByPostcodeArgs = {
    postcode: Scalars['String'];
};

export type QueryAgentBranchArgs = {
    id: Scalars['Int'];
};

export type QueryAgentExclusionsArgs = {
    criteria: AgentExclusionsCriteria;
};

export type QueryAreaArgs = {
    geoIdentifier?: Maybe<Scalars['GeoIdentifier']>;
    geoString?: Maybe<Scalars['NonEmptyString']>;
};

export type QueryArticleCategoryArgs = {
    preview?: Maybe<Scalars['Boolean']>;
    slug: Scalars['String'];
};

export type QueryArticleTagArgs = {
    slug: Scalars['String'];
};

export type QueryArticleArgs = {
    categorySlug?: Maybe<Scalars['String']>;
    slug: Scalars['String'];
    preview?: Maybe<Scalars['Boolean']>;
};

export type QueryArticleCollectionArgs = {
    id: Scalars['String'];
};

export type QueryArticlesArgs = {
    category?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

export type QueryAuthorArgs = {
    slug: Scalars['String'];
};

export type QueryAuthorsArgs = {
    limit?: Maybe<Scalars['Int']>;
    skip?: Maybe<Scalars['Int']>;
};

export type QueryBackToResultsLinkArgs = {
    id: Scalars['Int'];
    searchIdentifier?: Maybe<Scalars['String']>;
    sessionId?: Maybe<Scalars['String']>;
};

export type QueryBreadcrumbsArgs = {
    path?: Maybe<Scalars['String']>;
    uprn?: Maybe<Scalars['String']>;
};

export type QueryChapterArgs = {
    slug: Scalars['String'];
    preview?: Maybe<Scalars['Boolean']>;
};

export type QueryCmsEntryArgs = {
    id: Scalars['String'];
    preview?: Maybe<Scalars['Boolean']>;
};

export type QueryDiscoverMoreArgs = {
    path: Scalars['String'];
};

export type QueryEchoArgs = {
    message: Scalars['String'];
};

export type QueryEmailAllArgs = {
    path: Scalars['String'];
};

export type QueryGeoSuggestionArgs = {
    locationPrefix: Scalars['String'];
};

export type QueryGetSuggestedAddressesArgs = {
    address: Scalars['String'];
};

export type QueryGoogleMapUrlSignaturesArgs = {
    urls: Array<Scalars['String']>;
};

export type QueryGovSchemesArgs = {
    slug: Scalars['String'];
};

export type QueryGuideArgs = {
    slug: Scalars['String'];
    preview?: Maybe<Scalars['Boolean']>;
};

export type QueryListingArgs = {
    id: Scalars['Int'];
    include?: Maybe<Array<Maybe<ListingInclusion>>>;
};

export type QueryListingsArgs = {
    ids: Array<Scalars['Int']>;
};

export type QueryListingDetailsArgs = {
    id: Scalars['Int'];
    include?: Maybe<Array<Maybe<ListingInclusion>>>;
};

export type QueryListingPreviewArgs = {
    id: Scalars['Int'];
};

export type QueryMarketActivityArgs = {
    geoIdentifier?: Maybe<Scalars['GeoIdentifier']>;
    geoString?: Maybe<Scalars['NonEmptyString']>;
    rangeMonths?: MarketActivityWindow;
    houseType?: HouseType;
};

export type QueryMarketStatsArgs = {
    criteria: MarketStatsCriteria;
};

export type QueryNavbarArgs = {
    id: Scalars['String'];
};

export type QueryViewCountArgs = {
    listingId: Scalars['String'];
};

export type QueryNewHomesDevelopmentDataArgs = {
    deprecatedBranchId: Scalars['Int'];
    id: Scalars['Int'];
};

export type QueryNewHomesSearchArgs = {
    after?: Maybe<Scalars['ID']>;
    before?: Maybe<Scalars['ID']>;
    first?: Maybe<Scalars['Int']>;
    input?: Maybe<NewHomesDevelopmentSearchInput>;
    last?: Maybe<Scalars['Int']>;
};

export type QueryNewsAndGuidesArgs = {
    preview?: Maybe<Scalars['Boolean']>;
};

export type QueryPointsOfInterestArgs = {
    longitude: Scalars['Float'];
    latitude: Scalars['Float'];
};

export type QueryPropertiesArgs = {
    postcode: Scalars['String'];
};

export type QueryPropertyArgs = {
    id?: Maybe<Scalars['String']>;
    uprn?: Maybe<Scalars['String']>;
};

export type QueryPropertyLastSaleArgs = {
    propertyId: Scalars['Int'];
};

export type QueryRedirectsArgs = {
    path: Scalars['String'];
};

export type QuerySavedPropertiesArgs = {
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    after?: Maybe<Scalars['ID']>;
    before?: Maybe<Scalars['ID']>;
};

export type QuerySearchResultsArgs = {
    path: Scalars['String'];
};

export type QuerySearchResultsV2Args = {
    input?: Maybe<SearchResultsV2Input>;
};

export type QuerySearchResultsByParamsArgs = {
    params: PathByParamFields;
};

export type QuerySeoAccordionsArgs = {
    path: Scalars['String'];
};

export type QuerySmallPrintArgs = {
    smallPrintName: Scalars['String'];
};

export type QueryTrackedPropertiesArgs = {
    first?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
};

export type QueryPropertiesSearchArgs = {
    after?: Maybe<Scalars['ID']>;
    first?: Maybe<Scalars['PositiveInt']>;
    input: PropertySearchParams;
};

export type QueryUserLoginMethodsArgs = {
    email: Scalars['String'];
};

export type QueryValuationAddressArgs = {
    propertyId: Scalars['String'];
};

export type QueryValuationBranchArgs = {
    branchId: Scalars['Int'];
};

export type QueryValuationBranchesArgs = {
    propertyId: Scalars['Int'];
    transactionType: TransactionType;
    v2Seed: Scalars['String'];
    routeNewValuationBranchLogic?: Maybe<Scalars['Boolean']>;
};

export type QueryZooplaValuationToolDataArgs = {
    customerKey: Scalars['ID'];
};

/** Data object defining quote content model. */
export type Quote = {
    __typename?: 'Quote';
    author: AuthorDetails;
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
};

export type RecentSale = {
    __typename?: 'RecentSale';
    date?: Maybe<Scalars['String']>;
    price?: Maybe<Scalars['Int']>;
    propertyId?: Maybe<Scalars['Int']>;
    propertyTypeLabel?: Maybe<Scalars['String']>;
    streetAddress?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
};

export type Redirect = {
    __typename?: 'Redirect';
    code?: Maybe<Scalars['String']>;
    redirectUri?: Maybe<Scalars['String']>;
};

export type RegisterUserInput = {
    email: Scalars['String'];
    confirmEmail?: Maybe<Scalars['String']>;
    password: Scalars['String'];
    username?: Maybe<Scalars['String']>;
    contactName?: Maybe<Scalars['String']>;
    propertyStatus?: Maybe<Scalars['String']>;
    consents?: Maybe<Array<ConsentsInput>>;
};

export type RegisterUserPayload = {
    __typename?: 'RegisterUserPayload';
    success: Scalars['Boolean'];
    pageAfterLoginUrl?: Maybe<Scalars['String']>;
    errorMessage?: Maybe<Scalars['String']>;
    errorCode?: Maybe<Scalars['String']>;
    errorField?: Maybe<Scalars['String']>;
};

export type RentEstimate = {
    __typename?: 'RentEstimate';
    lowerPrice: Scalars['Int'];
    currentPrice: Scalars['Int'];
    upperPrice: Scalars['Int'];
};

/**
 * Reports error entity. The `errorCode` provides a simple identifier
 * to the frontend to handle error propertly
 */
export type ReportsError = {
    __typename?: 'ReportsError';
    /** The Enum providing minimal information on what happened in the backend */
    errorCode?: Maybe<ReportsErrorCode>;
};

/**
 * General error codes that can be returned to the frontend for better control
 * of component outputs.
 */
export enum ReportsErrorCode {
    ApplicationError = 'APPLICATION_ERROR',
    BadRequest = 'BAD_REQUEST',
    InvalidPropertyType = 'INVALID_PROPERTY_TYPE',
    PostcodeNotFound = 'POSTCODE_NOT_FOUND',
    PropertyNotFound = 'PROPERTY_NOT_FOUND',
    RequestTimeout = 'REQUEST_TIMEOUT',
    UnknownError = 'UNKNOWN_ERROR'
}

/** Data associated with a query for ONLY the responsive images relating to a single listing */
export type ResponsiveImg = {
    __typename?: 'ResponsiveImg';
    /** Width of image */
    width?: Maybe<Scalars['Int']>;
    /** Image URL */
    src?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY listings */
export type Results = {
    __typename?: 'Results';
    /** Targeting used for advertisements. the targeting will be sent to the advertisers as key/value pairs */
    adTargeting?: Maybe<AdTargeting>;
    /** Page data used for ecommerce */
    analyticsEcommerce?: Maybe<AnalyticsEcommerce>;
    /** Page data used for analytics */
    analyticsTaxonomy?: Maybe<AnalyticsTaxonomy>;
    /** Query filters */
    filters?: Maybe<Filters>;
    /** Links */
    links?: Maybe<Links>;
    /** Page data used for analytics */
    listings?: Maybe<Listings>;
    /** Metadata */
    metaInfo?: Maybe<Meta>;
    /** Data on pagination */
    pagination?: Maybe<Pagination>;
    /** URL Encoded polygon coordinates representing searched area */
    polyenc?: Maybe<Scalars['String']>;
    /** Polygon coordinates representing searched area */
    polygon?: Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Float']>>>>>>>;
    /** Polygon data representing searched area */
    polygonV2?: Maybe<Polygon>;
    /** Saved search and alerts */
    savedSearchAndAlerts?: Maybe<SavedSearchAndAlerts>;
    /** Seoblurb */
    seoBlurb?: Maybe<SeoBlurb>;
    /** Sort order */
    sortOrder?: Maybe<SortOrder>;
    /** Title */
    title?: Maybe<Scalars['String']>;
    /** User alert id */
    userAlertId?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY listings */
export type ResultsPolygonArgs = {
    path: Scalars['String'];
};

/** Data associated with a query for ONLY listings */
export type ResultsPolygonV2Args = {
    path: Scalars['String'];
};

/** A single item that returns data from a non-exhaustive list of given types */
export type ResultsItem = {
    __typename?: 'ResultsItem';
    /** Data of the item type provided, this is extensible to any other item type defined */
    data?: Maybe<FeedItem>;
    /** Defines the type of result data expected, currently LISTING */
    type?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY results */
export type ResultsList = {
    __typename?: 'ResultsList';
    /** Extended is reserved for listing only types that populate when there are less than a full page of results */
    extended?: Maybe<Array<Maybe<Listing>>>;
    /** Main are the resulting items that will be displayed in the search results feed */
    main?: Maybe<Array<Maybe<ResultsItem>>>;
};

/** Data associated with a query for items (primarily listings) to display */
export type ResultsV2 = {
    __typename?: 'ResultsV2';
    /** Targeting used for advertisements. the targeting will be sent to the advertisers as key/value pairs */
    adTargeting?: Maybe<AdTargeting>;
    /** Page data used for ecommerce */
    analyticsEcommerce?: Maybe<AnalyticsEcommerce>;
    /** Page data used for analytics */
    analyticsTaxonomy?: Maybe<AnalyticsTaxonomy>;
    /** Query filters */
    filters?: Maybe<Filters>;
    /** Links */
    links?: Maybe<Links>;
    /** Metadata */
    metaInfo?: Maybe<Meta>;
    /** Data on pagination */
    pagination?: Maybe<Pagination>;
    /** Polyenc */
    polyenc?: Maybe<Scalars['String']>;
    /** Polygon */
    polygon?: Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['Float']>>>>>>>;
    /** Results mapped from the list of available types, the results list can contain none or more data types */
    results?: Maybe<ResultsList>;
    /** Saved search and alerts */
    savedSearchAndAlerts?: Maybe<SavedSearchAndAlerts>;
    /** Seoblurb */
    seoBlurb?: Maybe<SeoBlurb>;
    /** Sort order */
    sortOrder?: Maybe<SortOrder>;
    /** Title */
    title?: Maybe<Scalars['String']>;
    /** User alert id */
    userAlertId?: Maybe<Scalars['String']>;
};

/** Data associated with a query for items (primarily listings) to display */
export type ResultsV2PolygonArgs = {
    path: Scalars['String'];
};

/** Common data object defining Contentful rich text content type. */
export type RichText = {
    __typename?: 'RichText';
    content?: Maybe<Scalars['JSON']>;
    data?: Maybe<Scalars['JSON']>;
    nodeType: Scalars['String'];
};

/** Data object defining rich text and image content model. */
export type RichTextAndImage = {
    __typename?: 'RichTextAndImage';
    document: RichText;
    image: ContentfulImage;
};

/** Data containing the amount of bathrooms, bedrooms and living rooms in our Listing */
export type RoomCount = {
    __typename?: 'RoomCount';
    numBathrooms?: Maybe<Scalars['Int']>;
    numBedrooms?: Maybe<Scalars['Int']>;
    numLivingRooms?: Maybe<Scalars['Int']>;
};

export type Row = {
    __typename?: 'Row';
    links?: Maybe<Array<Maybe<Link>>>;
};

export type SaleEstimate = {
    __typename?: 'SaleEstimate';
    lowerPrice: Scalars['Int'];
    currentPrice: Scalars['Int'];
    upperPrice: Scalars['Int'];
    confidenceLevel: ConfidenceLevel;
    valueChange?: Maybe<ValueChange>;
};

/** Deprecated (can now be replaced with SaleEstimate) */
export type SaleEstimateV2 = {
    __typename?: 'SaleEstimateV2';
    lowerPrice: Scalars['Int'];
    currentPrice: Scalars['Int'];
    upperPrice: Scalars['Int'];
    confidenceLevel: ConfidenceLevel;
    valueChange?: Maybe<ValueChange>;
};

export type SavedListing = {
    __typename?: 'SavedListing';
    creationDate: Scalars['String'];
    listingStatus: ListingStatus;
    listing: ListingData;
};

export enum SavedListingUpdateErrorStatusCode {
    UserNotFound = 'user_not_found',
    ListingNotFound = 'listing_not_found',
    BadRequest = 'bad_request'
}

export type SavedListingUpdateInvalidInputError = {
    __typename?: 'SavedListingUpdateInvalidInputError';
    errorCode: SavedListingUpdateErrorStatusCode;
};

export type SavedListingUpdateResult =
    | SavedListingUpdateResultSuccess
    | SavedListingUpdateInvalidInputError;

export type SavedListingUpdateResultSuccess = {
    __typename?: 'SavedListingUpdateResultSuccess';
    successCode: SavedListingUpdateSuccessStatusCode;
};

export enum SavedListingUpdateSuccessStatusCode {
    Saved = 'saved',
    AlreadySaved = 'already_saved',
    Deleted = 'deleted'
}

export type SavedProperties =
    | SavedPropertyListResult
    | SavedPropertyListInvalidInputError;

export enum SavedPropertyListErrorStatusCode {
    UserNotFound = 'user_not_found',
    BadRequest = 'bad_request',
    InvalidPaginationParams = 'invalid_pagination_params',
    PaginationIdNotFound = 'pagination_id_not_found'
}

export type SavedPropertyListInvalidInputError = {
    __typename?: 'SavedPropertyListInvalidInputError';
    errorCode: SavedPropertyListErrorStatusCode;
};

export type SavedPropertyListResult = {
    __typename?: 'SavedPropertyListResult';
    listings?: Maybe<Array<SavedListing>>;
    listingIds?: Maybe<Array<Scalars['Int']>>;
    pageInfo: PageInfo;
};

/** Data object representing a search that a user has saved, that may contain alerts */
export type SavedSearch = {
    __typename?: 'SavedSearch';
    /** Array of alerts, one alert per alert channel */
    alerts?: Maybe<Array<SavedSearchAlert>>;
    /** Object containing the search arguments */
    filters: SavedSearchFilters;
    /**
     * Identifier for the search.
     * Note: this comes from the public api as search_fp or the search fingerprint, and is used to merge multiple search alerts into one search.
     */
    id: Scalars['ID'];
    /** User editable name of the search. */
    name?: Maybe<Scalars['String']>;
    /**
     * Date on which the search was last edited.
     * Formatted to RFC 3339
     * eg. "2021-11-23T11:51:29.000Z"
     */
    updatedOn?: Maybe<Scalars['DateTime']>;
};

/** Data object representing an alert on a search */
export type SavedSearchAlert = {
    __typename?: 'SavedSearchAlert';
    /**
     * Channel via which the user will recieve alerts.
     * eg. "email", or "mobile".
     */
    channel: SavedSearchAlertChannel;
    /**
     * Frequency at which the user will recieve alerts for the channel, in days.
     * 0 means the alerts are instant.
     * Null means the user will not recieve alerts.
     * eg. 1 means 1 alert per day, and 7 means one alert per week
     */
    frequency?: Maybe<Scalars['Int']>;
    /**
     * Identifier for the alert.
     * Note: comes from the public-api as searchIdentifier, but we use as an alert id after the searches have been merge by searchFp
     */
    id: Scalars['ID'];
};

/** Channel through which a user may recieve an alert for a saved search */
export enum SavedSearchAlertChannel {
    /** Email alerting channel */
    Email = 'EMAIL',
    /** Push notification alerting channel */
    Mobile = 'MOBILE'
}

/** Channel through which a user may recieve an alert for a saved search */
export type SavedSearchAlertInput = {
    /**
     * Channel via which the user will recieve alerts.
     * eg. "email", or "mobile".
     */
    channel: SavedSearchAlertChannel;
    /**
     * Frequency at which the user will recieve alerts for the channel, in days.
     * 0 means the alerts are instant.
     * Null means the user will not recieve alerts.
     * eg. 1 means 1 alert per day, and 7 means one alert per week
     */
    frequency?: Maybe<Scalars['Int']>;
};

/** Data associated with a query for SavedSearchAndAlerts */
export type SavedSearchAndAlerts = {
    __typename?: 'SavedSearchAndAlerts';
    /** Current alert frequency */
    currentFrequency?: Maybe<AlertFrequencyOption>;
    /** Frequency */
    frequency?: Maybe<Array<Maybe<AlertFrequencyOption>>>;
    /** URI for creating an alert and saving a search */
    uri?: Maybe<Scalars['String']>;
};

/** Data object containing arguments for the search */
export type SavedSearchFilters = {
    __typename?: 'SavedSearchFilters';
    /**
     * The date the property was added, can be:
     * '24_hours', '3_days', '7_days', '14_days', '30_days'
     * '' means anytime and is the default
     */
    added: Scalars['String'];
    /**
     * When true, only include listings with bills include
     * Defaults to false
     * Only relevent for "rent" listingStatus searches.
     */
    billsIncluded: Scalars['Boolean'];
    /**
     * Returns "residential", "commercial", "overseas" or potentially other categories.
     * Defaults to "residential".
     */
    category: Scalars['String'];
    /**
     * Furnished type to include.
     * eg. "part_furnished", or "unfurnished", or "furnished".
     * "Any" means all furnishing types are included, and is the default.
     * Only relevent for "rent" listingStatus searches.
     */
    furnishedState: Scalars['String'];
    /** Equivalent to what's returned by the geoSuggestion api */
    geoSuggestion: SavedSearchGeoSuggestion;
    /**
     * When true, show let agreed in addition to listing still to let
     * Defaults to false
     * Only relevent for "rent" listingStatus searches.
     */
    includeRented: Scalars['Boolean'];
    /**
     * When true, include retirement homes
     * Defaults to false
     * Only relevent for "sale" listingStatus searches.
     */
    includeRetirementHomes: Scalars['Boolean'];
    /**
     * Defaults to false
     * Only relevent for "rent" listingStatus searches.
     */
    includeSharedAccommodation: Scalars['Boolean'];
    /**
     * Defaults to true
     * Only relevent for "sale" listingStatus searches.
     */
    includeSharedOwnership: Scalars['Boolean'];
    /**
     * Whether to include sold listings
     * defaults to false
     * Only relevent for "sale" listingStatus searches.
     */
    includeSold: Scalars['Boolean'];
    /**
     * Whether or not action listings should be included.
     * Defaults to true.
     * Only relevent for "sale" listingStatus searches.
     */
    isAuction: Scalars['Boolean'];
    /**
     * Comma seperated list of keywords used to filter the search.
     * eg. "garden, patio"
     * Empty string when no keywords are used the filter, which is the default.
     */
    keywords: Scalars['String'];
    /**
     * Returns "for-sale" or "to-rent".
     * Defaults to 'for-sale'
     */
    section: Scalars['String'];
    /**
     * Number of beds
     * 0 means "studio"
     * Empty string when no maximum, which is the default.
     */
    bedsMax: Scalars['String'];
    /**
     * Number in pounds.
     * eg. "100000" means £100,000.00.
     * "0" when no maximum, which is the default.
     */
    priceMax: Scalars['String'];
    /**
     * Number of beds
     * 0 means "studio"
     * Empty string when no minimum, which is the default.
     */
    bedsMin: Scalars['String'];
    /**
     * Number in pounds, eg "100000" means £100,000.00.
     * "0" when no minimum, which is the default.
     */
    priceMin: Scalars['String'];
    /**
     * Whether to include new homes
     * "exclude" will not include new homes
     * Any other string, or null, will include new homes
     * Defaults to null
     * Only relevent for "sale" listingStatus searches.
     */
    newHomes?: Maybe<Scalars['String']>;
    /**
     * When true, only include listings which allow pets
     * Only relevent for "rent" listingStatus searches.
     */
    petsAllowed: Scalars['Boolean'];
    /**
     * Frequency at which rent is to be paid. eg. "per_month".
     * Defaults to "per_month".
     * Only relevent for "rent" listingStatus searches.
     */
    priceFrequency: Scalars['String'];
    /**
     * Array of property types to include.
     * eg. ["detached", "terraced","semi_detached", "flats", "farms_land", "bungalow", "park_home"]
     * Empty array when all property types are included, which is the default.
     */
    propertySubType: Array<Scalars['String']>;
    /**
     * Radius from the search location in number of miles.
     * May include decimal amounts
     * eg "0.25" means 1/4 of a mile, and "20" means 20 miles
     * Defaults to "0" which means the specified area only.
     */
    radius: Scalars['String'];
};

/** Equivalent to what's returned by the geoSuggestion api */
export type SavedSearchGeoSuggestion = {
    __typename?: 'SavedSearchGeoSuggestion';
    /** Note: Stored as "Area" but functionally equivalent to the geoLabel from the geoService and location.value used by the search service */
    geoLabel?: Maybe<Scalars['String']>;
    /** Note: Stored as "Identifier" but functionally equivalent to the geoIdentifier used by the geo service and location.identifier used by the search service */
    geoIdentifier?: Maybe<Scalars['String']>;
};

/** Equivalent to what's returned by the geoSuggestion api */
export type SavedSearchGeoSuggestionInput = {
    /** Note: Stored as "Identifier" but functionally equivalent to the geoIdentifier used by the geo service and location.identifier used by the search service */
    geoIdentifier: Scalars['String'];
    /** Note: Stored as "Area" but functionally equivalent to the geoLabel from the geoService and location.value used by the search service */
    geoLabel: Scalars['String'];
};

/** Details of a search to create or update */
export type SavedSearchInput = {
    /**
     * The date the property was added, can be:
     * '24_hours', '3_days', '7_days', '14_days', '30_days'
     * '' means anytime and is the default
     */
    added?: Maybe<Scalars['String']>;
    /** Array of alerts, one alert per alert channel */
    alerts?: Maybe<Array<SavedSearchAlertInput>>;
    /**
     * Number of beds
     * 0 means "studio"
     * Empty string when no maximum, which is the default.
     */
    bedsMax?: Maybe<Scalars['String']>;
    /**
     * Number of beds
     * 0 means "studio"
     * Empty string when no minimum, which is the default.
     */
    bedsMin?: Maybe<Scalars['String']>;
    /**
     * When true, only include listings with bills include
     * Defaults to false
     * Only relevent for "rent" listingStatus searches.
     */
    billsIncluded?: Maybe<Scalars['Boolean']>;
    /**
     * Furnished type to include.
     * eg. "part_furnished", or "unfurnished", or "furnished".
     * "Any" means all furnishing types are included, and is the default.
     * Only relevent for "rent" listingStatus searches.
     */
    furnishedState?: Maybe<Scalars['String']>;
    /** Equivalent to what's returned by the geoSuggestion api */
    geoSuggestion: SavedSearchGeoSuggestionInput;
    /**
     * When true, show let agreed in addition to listing still to let
     * Defaults to false
     * Only relevent for "rent" listingStatus searches.
     */
    includeRented?: Maybe<Scalars['Boolean']>;
    /**
     * When true, include retirement homes
     * Defaults to false
     * Only relevent for "sale" listingStatus searches.
     */
    includeRetirementHomes?: Maybe<Scalars['Boolean']>;
    /**
     * Defaults to false
     * Only relevent for "rent" listingStatus searches.
     */
    includeSharedAccommodation?: Maybe<Scalars['Boolean']>;
    /**
     * Defaults to true
     * Only relevent for "sale" listingStatus searches.
     */
    includeSharedOwnership?: Maybe<Scalars['Boolean']>;
    /**
     * Whether to include sold listings
     * defaults to false
     * Only relevent for "sale" listingStatus searches.
     */
    includeSold?: Maybe<Scalars['Boolean']>;
    /**
     * Whether or not action listings should be included.
     * Defaults to true.
     * Only relevent for "sale" listingStatus searches.
     */
    isAuction?: Maybe<Scalars['Boolean']>;
    /**
     * Comma seperated list of keywords used to filter the search.
     * eg. "garden, patio"
     * Empty string when no keywords are used the filter, which is the default.
     */
    keywords?: Maybe<Scalars['String']>;
    /**
     * User editable name for the search.
     * Defaults to the value of area.
     */
    name?: Maybe<Scalars['String']>;
    /**
     * Whether to include new homes
     * "exclude" will not include new homes
     * Any other string, or null, will include new homes
     * Defaults to null
     * Only relevent for "sale" listingStatus searches.
     */
    newHomes?: Maybe<Scalars['String']>;
    /**
     * When true, only include listings which allow pets
     * Defaults to false
     * Only relevent for "rent" listingStatus searches.
     */
    petsAllowed?: Maybe<Scalars['Boolean']>;
    /**
     * Number in pounds.
     * eg. "100000" means £100,000.00.
     * "0" when no maximum, which is the default.
     */
    priceMax?: Maybe<Scalars['String']>;
    /**
     * Number in pounds, eg "100000" means £100,000.00.
     * "0" when no minimum, which is the default.
     */
    priceMin?: Maybe<Scalars['String']>;
    /**
     * Array of property types to include.
     * eg. ["detached", "terraced","semi_detached", "flats", "farms_land", "bungalow", "park_home"]
     * Empty array when all property types are included, which is the default.
     */
    propertySubType?: Maybe<Array<Scalars['String']>>;
    /**
     * Radius from the search location in number of miles.
     * May include decimal amounts
     * eg "0.25" means 1/4 of a mile, and "20" means 20 miles
     * Defaults to "0" which means the specified area only.
     */
    radius?: Maybe<Scalars['String']>;
    /**
     * May be either "for-sale" or "to-rent".
     * Defaults to "for-sale" if given another string
     */
    section: Scalars['String'];
};

export type SearchFields = {
    description?: Maybe<Scalars['String']>;
    userAlertId?: Maybe<Scalars['String']>;
    q?: Maybe<Scalars['String']>;
    section?: Maybe<Scalars['String']>;
    category?: Maybe<Scalars['String']>;
    priceFrequency?: Maybe<Scalars['String']>;
    includeSharedAccommodation?: Maybe<Scalars['String']>;
    keywords?: Maybe<Scalars['String']>;
    identifier?: Maybe<Scalars['String']>;
    radius?: Maybe<Scalars['String']>;
    added?: Maybe<Scalars['String']>;
    availableFrom?: Maybe<Scalars['String']>;
    priceMin?: Maybe<Scalars['String']>;
    priceMax?: Maybe<Scalars['String']>;
    bedsMin?: Maybe<Scalars['String']>;
    bedsMax?: Maybe<Scalars['String']>;
    rentalTerm?: Maybe<Scalars['String']>;
    petsAllowed?: Maybe<Scalars['String']>;
    billsIncluded?: Maybe<Scalars['String']>;
    includeSold?: Maybe<Scalars['String']>;
    includeRented?: Maybe<Scalars['String']>;
    furnishedState?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    propertySubType?: Maybe<Array<Maybe<Scalars['String']>>>;
    feature?: Maybe<Array<Maybe<Scalars['String']>>>;
    includeRetirementHomes?: Maybe<Scalars['String']>;
    isRetirementHome?: Maybe<Scalars['String']>;
    includeSharedOwnership?: Maybe<Scalars['String']>;
    isSharedOwnership?: Maybe<Scalars['String']>;
    buyerIncentive?: Maybe<Scalars['String']>;
    newHomes?: Maybe<Scalars['String']>;
    isAuction?: Maybe<Scalars['String']>;
    chainFree?: Maybe<Scalars['String']>;
    reducedPriceOnly?: Maybe<Scalars['String']>;
    viewType?: Maybe<Scalars['String']>;
    polyenc?: Maybe<Scalars['String']>;
};

/**
 * Location info passed in by a client. Can be the values passed in by a geoSuggestion
 * which could be like:
 * value: 'London Fields, London'
 * identifier: 'london-fields'
 */
export type SearchParamLocation = {
    /** A location value */
    value: Scalars['String'];
    /** A location identifier passed back by the geoSuggestion api */
    identifier: Scalars['String'];
};

/**
 * Input for a search result query
 * path: optional string
 */
export type SearchResultsV2Input = {
    /** The path of the URL initially queried */
    path?: Maybe<Scalars['String']>;
};

/** Data object defining secondary search content model. */
export type SecondarySearch = {
    __typename?: 'SecondarySearch';
    heading?: Maybe<Scalars['String']>;
    image?: Maybe<Scalars['String']>;
    searchButtonText?: Maybe<Scalars['String']>;
    searchFilterType?: Maybe<Scalars['String']>;
    searchLabel?: Maybe<Scalars['String']>;
};

export type SeoAccordions = {
    __typename?: 'SeoAccordions';
    category?: Maybe<Scalars['String']>;
    expanded?: Maybe<Scalars['Boolean']>;
    geo?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    propertyType?: Maybe<Scalars['String']>;
    section?: Maybe<Scalars['String']>;
    transactionType?: Maybe<Scalars['String']>;
    rows?: Maybe<Array<Maybe<Row>>>;
    links?: Maybe<Array<Maybe<Link>>>;
};

/** Data associated with a query for Seo Blurb */
export type SeoBlurb = {
    __typename?: 'SeoBlurb';
    /** Area label */
    areaLabel?: Maybe<Scalars['String']>;
    /** Area URL URL */
    areaUri?: Maybe<Scalars['String']>;
    /** category */
    category?: Maybe<Scalars['String']>;
    /** property type */
    propertyType?: Maybe<Scalars['String']>;
    /** Transaction type */
    transactionType?: Maybe<Scalars['String']>;
};

/** Data object defining seo search links content model. */
export type SeoSearchLinks = {
    __typename?: 'SeoSearchLinks';
    headerPanel?: Maybe<RichText>;
    heading?: Maybe<Scalars['String']>;
};

export type SigninUserInput = {
    password: Scalars['String'];
    email?: Maybe<Scalars['String']>;
    rememberMe?: Maybe<Scalars['Boolean']>;
};

export type SigninUserPayload = {
    __typename?: 'SigninUserPayload';
    success: Scalars['Boolean'];
    pageAfterLoginUrl?: Maybe<Scalars['String']>;
    errorMessage?: Maybe<Scalars['String']>;
    errorCode?: Maybe<Scalars['String']>;
    errorField?: Maybe<Scalars['String']>;
};

/** Similar listing type returned by Similar Listing criteria */
export type SimilarListing = {
    __typename?: 'SimilarListing';
    branch?: Maybe<AgentBranch>;
    displayAddress?: Maybe<Scalars['String']>;
    featurePreview?: Maybe<Array<Maybe<Feature>>>;
    imagePreview?: Maybe<Image>;
    listingId: Scalars['ID'];
    listingUris?: Maybe<ListingUris>;
    pricing: ListingPricing;
    statusSummary?: Maybe<ListingStatusSummary>;
    tags?: Maybe<Array<Maybe<ListingTag>>>;
    title: Scalars['String'];
};

/** Search similar listings based on different criterias */
export enum SimilarListingsCriteria {
    Price = 'PRICE',
    Bedrooms = 'BEDROOMS',
    Distance = 'DISTANCE',
    Default = 'DEFAULT'
}

export type SimpleResponse = {
    __typename?: 'SimpleResponse';
    status?: Maybe<Scalars['Int']>;
    statusText?: Maybe<Scalars['String']>;
    body?: Maybe<Scalars['String']>;
};

/** Data object defining small print content model. */
export type SmallPrint = {
    __typename?: 'SmallPrint';
    smallPrintBody: Scalars['String'];
    smallPrintName: Scalars['String'];
};

/** Union type for fetching small print objects and potential error statuses. */
export type SmallPrintResult = SmallPrint | InvalidInputError;

/**
 * The list consists of the various input fiels required
 * to be sent to the apple authentication API.
 */
export type SocialSignInAppleInput = {
    /** The users appleId */
    appleId: Scalars['String'];
    /** The email address the login methods are for. */
    email: Scalars['String'];
    /** Optional - The first name of the user. */
    firstName?: Maybe<Scalars['String']>;
    /** Optional - The last name of the user. */
    lastName?: Maybe<Scalars['String']>;
};

/** The response returned by the apple authentication endpoint */
export type SocialSignInAppleResponse = {
    __typename?: 'SocialSignInAppleResponse';
    sessionId?: Maybe<Scalars['String']>;
    success: Scalars['Boolean'];
    userCreatedDate?: Maybe<Scalars['String']>;
};

/** The response returned by the apple Facebook endpoint */
export type SocialSignInFacebookResponse = {
    __typename?: 'SocialSignInFacebookResponse';
    success: Scalars['Boolean'];
};

/** The response returned by the google one tap authentication endpoint */
export type SocialSignInGoogleOneTapResponse = {
    __typename?: 'SocialSignInGoogleOneTapResponse';
    success: Scalars['Int'];
};

/** The response returned by the google authentication endpoint */
export type SocialSignInGoogleResponse = {
    __typename?: 'SocialSignInGoogleResponse';
    success: Scalars['Boolean'];
};

/** Data associated with a query for Sort order option */
export type SortOrder = {
    __typename?: 'SortOrder';
    /** Current sort order */
    currentSortOrder?: Maybe<Scalars['String']>;
    /** Sort order options */
    options?: Maybe<Array<Maybe<SortOrderOption>>>;
};

/** Data associated with a query for Sort order option */
export type SortOrderOption = {
    __typename?: 'SortOrderOption';
    /** i18n label key */
    i18NLabelKey?: Maybe<Scalars['String']>;
    /** Sort order value */
    value?: Maybe<Scalars['String']>;
    /** selected */
    selected?: Maybe<Scalars['Boolean']>;
};

/** Data associated with a query for ONLY a listings sub imagery */
export type SubImage = {
    __typename?: 'SubImage';
    /** URL for small image */
    small?: Maybe<Scalars['String']>;
    /** URL for large image */
    large?: Maybe<Scalars['String']>;
    /** Image caption */
    caption?: Maybe<Scalars['String']>;
};

export type Subitem = {
    __typename?: 'Subitem';
    order?: Maybe<Scalars['Int']>;
    label?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    uri?: Maybe<Scalars['String']>;
    i18nLabelKey?: Maybe<Scalars['String']>;
    tracking?: Maybe<Scalars['String']>;
    datetime?: Maybe<Scalars['String']>;
    nofollow?: Maybe<Scalars['Boolean']>;
};

export type Subnav = {
    __typename?: 'Subnav';
    label?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    position?: Maybe<Scalars['Int']>;
    i18nLabelKey?: Maybe<Scalars['String']>;
    tracking?: Maybe<Scalars['String']>;
    subitems?: Maybe<Array<Maybe<Subitem>>>;
};

export type SuggestedAddresses = {
    __typename?: 'SuggestedAddresses';
    v?: Maybe<Scalars['String']>;
    i?: Maybe<Scalars['String']>;
};

/** Data object defining table content model. */
export type Table = {
    __typename?: 'Table';
    content: Array<Array<Scalars['String']>>;
    heading: Scalars['String'];
    subHeading?: Maybe<Scalars['String']>;
};

/** Data associated with a query for ONLY a tag relating to a single listing */
export type Tag = {
    __typename?: 'Tag';
    /** Content */
    content?: Maybe<Scalars['String']>;
};

export type TrackedProperty = {
    __typename?: 'TrackedProperty';
    /** @deprecated Please use uprn from the parent */
    uprn?: Maybe<Scalars['String']>;
    isTracked?: Maybe<Scalars['Boolean']>;
    relationship?: Maybe<TrackedPropertyRelationship>;
};

export type TrackedPropertyInput = {
    /** The id of the consent that the user has given to track this property. */
    consentId?: Maybe<Scalars['String']>;
    /**
     * The literal text displayed to a user to attract the user to track this property. This is required for legal audit
     * purposes.
     */
    consentText?: Maybe<Scalars['String']>;
    propertyId?: Maybe<Scalars['String']>;
    relationship?: Maybe<TrackedPropertyRelationship>;
    uprn: Scalars['String'];
};

export enum TrackedPropertyRelationship {
    Homeowner = 'HOMEOWNER',
    Landlord = 'LANDLORD',
    Tenant = 'TENANT',
    InterestedInBuying = 'INTERESTED_IN_BUYING',
    Interested = 'INTERESTED'
}

export enum TransactionType {
    Sale = 'SALE',
    Rent = 'RENT'
}

/** Data associated with a query for ONLY a transport link relating to a single listing */
export type Transport = {
    __typename?: 'Transport';
    /** Distance (as the crow flies) from listing to the transport link */
    distanceInMiles?: Maybe<Scalars['Float']>;
    /** Latitude for transport link */
    lat?: Maybe<Scalars['Float']>;
    /** Longitude of transport link */
    lng?: Maybe<Scalars['Float']>;
    /**
     * Point of interest types
     * - national_rail_station
     * - london_dlr_station
     * - london_underground_station
     * - london_overground_station
     * - uk_airport
     * - uk_ferry_port
     */
    poiType?: Maybe<Scalars['String']>;
    /** Name of transport link (e.g. "Surrey Quays") */
    title?: Maybe<Scalars['String']>;
    /** Transport link features */
    features?: Maybe<TransportFeatures>;
};

/** Data associated with a query for ONLY the transport features relating to a transport link */
export type TransportFeatures = {
    __typename?: 'TransportFeatures';
    /** Tube line */
    tubeLines?: Maybe<Scalars['String']>;
    /** Transport link zone */
    zone?: Maybe<Scalars['String']>;
};

export enum TypeOfEnquiry {
    Sell = 'SELL',
    Let = 'LET',
    Curious = 'CURIOUS',
    Remortgage = 'REMORTGAGE'
}

/**
 * Input used to identify the permission the user
 * should be unsubscribed from
 */
export type UnsubscribeUserPermissionInput = {
    /** The unsubscribeId of the user permission */
    unsubscribeId: Scalars['String'];
};

export type UpdateUserConsentsInput = {
    consents: Array<UserConsentInput>;
};

export enum Urgency {
    ZeroToThreeMonths = 'ZERO_TO_THREE_MONTHS',
    ThreeToSixMonths = 'THREE_TO_SIX_MONTHS',
    MoreThanSixMonths = 'MORE_THAN_SIX_MONTHS'
}

/** The User object */
export type User = {
    __typename?: 'User';
    brandPrimary?: Maybe<Scalars['String']>;
    /** Date at which the user first was created */
    creationDate?: Maybe<Scalars['String']>;
    /** The users email address */
    email?: Maybe<Scalars['String']>;
    /** Boolean representing whether the user is logged in or not */
    loggedIn?: Maybe<Scalars['Boolean']>;
    /** The users full name */
    name?: Maybe<Scalars['String']>;
    /** The users phone number */
    phone?: Maybe<Scalars['String']>;
    /** The possible email consents */
    possibleEmailConsents?: Maybe<Array<Maybe<PossibleEmailConsent>>>;
    /** Boolean representing whether the user has registered or not */
    registered?: Maybe<Scalars['Boolean']>;
    /** Date at which the user first was created */
    registrationSources?: Maybe<Array<Maybe<Scalars['String']>>>;
    /**
     * An array of searches the user has saved
     * Null when the user is not logged in, or there was an error
     */
    savedSearches?: Maybe<Array<SavedSearch>>;
    senderPropertyStatus?: Maybe<Scalars['String']>;
    status?: Maybe<Scalars['String']>;
    /** Object containing the users tracked properties */
    trackedProperties?: Maybe<UserTrackedProperties>;
    userId?: Maybe<Scalars['Int']>;
    userUuid?: Maybe<Scalars['String']>;
};

/** The User object */
export type UserTrackedPropertiesArgs = {
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
};

export enum UserAboutMe {
    FirstTimeBuyer = 'first_time_buyer',
    LookingToRent = 'looking_to_rent',
    Other = 'other',
    BuyerNotFirstTime = 'buyer_not_first_time',
    CuriousHavingALook = 'curious_having_a_look',
    PropertyToSell = 'property_to_sell',
    OfferOnOwnProperty = 'offer_on_own_property',
    LookingToInvest = 'looking_to_invest',
    PropertyToLet = 'property_to_let',
    RecentlySold = 'recently_sold',
    Agent = 'agent'
}

export type UserAboutMeInput = {
    situation: UserAboutMe;
};

export type UserConsentInput = {
    agreed: Scalars['Boolean'];
    id: Scalars['Int'];
};

export enum UserLoginMethod {
    Zoopla = 'zoopla',
    Primelocation = 'primelocation',
    Smartnewhomes = 'smartnewhomes',
    Alltheagents = 'alltheagents',
    Homesoverseas = 'homesoverseas',
    Google = 'google',
    Facebook = 'facebook'
}

export type UserLoginMethodsResponse = {
    __typename?: 'UserLoginMethodsResponse';
    /** The email address the login methods are for. */
    email: Scalars['String'];
    /** Whether or not the user has registered. */
    registered: Scalars['Boolean'];
    /**
     * The list consists of methods a user can use to login.
     * If a user registered directly then the primary
     * brand is given such as zoopla as well as any social
     * login methods such as facebook or google.
     */
    loginMethods: Array<UserLoginMethod>;
};

/** Properties tracked by a user. */
export type UserTrackedProperties = {
    __typename?: 'UserTrackedProperties';
    /**
     * The TOTAL number of properties tracked by a user, which may be different to the number of properties contained in
     * the array below due to pagination and a limit on the number of properties we return for each request.
     */
    total: Scalars['Int'];
    /**
     * Array of properties tracked by a user, possibly subject to pagination and a limit on the number of properties
     * we return.
     */
    items: Array<UserTrackedProperty>;
};

/** A property tracked by a user */
export type UserTrackedProperty = {
    __typename?: 'UserTrackedProperty';
    /** A property, containing id's, address info and other relevant attributes. */
    property: Property;
    /** The relationship of the user to this property (if given). e.g. 'homeowner', 'landlord', etc. */
    relationship?: Maybe<TrackedPropertyRelationship>;
    /** When this tracked property was last updated by the user. */
    lastUpdated?: Maybe<Scalars['String']>;
    /** Details about the permissions that this user has agreed to for this property */
    permissions?: Maybe<Permissions>;
};

/**
 * Valuation type that will be used as a mapper from the
 * API request to  http://api-property-details.qa.zoopla.co.uk/api/property/{propertyId}.
 */
export type ValuationAddress = {
    __typename?: 'ValuationAddress';
    /** @deprecated Temporary solution. Please use the type `Address` from properties instead for other use cases */
    fullAddress: Scalars['String'];
    /** @deprecated Temporary solution. Please use the type `Address` from properties instead for other use cases */
    postcode: Scalars['String'];
    /** @deprecated Temporary solution. Please use the type `Address` from properties instead for other use cases */
    streetName: Scalars['String'];
};

export type ValuationBranch = {
    __typename?: 'ValuationBranch';
    area?: Maybe<Scalars['String']>;
    averageRentPrice?: Maybe<Scalars['Int']>;
    averageSalePrice?: Maybe<Scalars['Int']>;
    branchDisplayName?: Maybe<Scalars['String']>;
    branchId: Scalars['Int'];
    /** Branch contact form URI. */
    branchUriName?: Maybe<Scalars['String']>;
    /** The ID of the company that the branch belongs to. */
    companyId?: Maybe<Scalars['Int']>;
    /** The name of the company that the branch belongs to. */
    companyName?: Maybe<Scalars['String']>;
    hasAppraisalBooster?: Maybe<Scalars['Boolean']>;
    logo?: Maybe<Scalars['String']>;
    numberOfRentListings?: Maybe<Scalars['Int']>;
    numberOfSaleListings?: Maybe<Scalars['Int']>;
    outcode?: Maybe<Scalars['String']>;
    selected?: Maybe<Scalars['Boolean']>;
    address?: Maybe<Scalars['String']>;
    postcode?: Maybe<Scalars['String']>;
    /** The branch average for the number of weeks for-sale properties are on the market. */
    averageSaleWeeksOnMarket?: Maybe<Scalars['Int']>;
};

export type ValuationLeadInput = {
    branchIds: Array<Scalars['Int']>;
    contactPreference?: Maybe<ContactPreference>;
    contactTimePreference?: Maybe<ContactTimePreference>;
    email: Scalars['String'];
    message?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    phone: Scalars['String'];
    propertyId: Scalars['Int'];
    transactionType: TransactionType;
    typeOfEnquiry: TypeOfEnquiry;
    urgency?: Maybe<Urgency>;
    url: Scalars['String'];
    userId?: Maybe<Scalars['Int']>;
    v2Seed: Scalars['String'];
};

export type ValuationLeadResponse = {
    __typename?: 'ValuationLeadResponse';
    uniqueLeadIdentifier: Scalars['String'];
    valuationBranches?: Maybe<Array<ValuationBranch>>;
};

export type ValueChange = {
    __typename?: 'ValueChange';
    percentageChange: Scalars['Float'];
    saleDate: Scalars['String'];
    numericChange: Scalars['Int'];
};

export type ViewCount = {
    __typename?: 'ViewCount';
    viewCount30day?: Maybe<Scalars['Int']>;
};

/** ViewCount object can either be a successful result or an error. */
export type ViewCountData = ViewCountResults | ReportsError;

/** ViewCount object be a successful result */
export type ViewCountResults = {
    __typename?: 'ViewCountResults';
    viewCount30day?: Maybe<Scalars['Int']>;
};

export type ZvtFormSubmissionValuationInput = {
    propertyId?: Maybe<Scalars['Int']>;
    recaptchaToken?: Maybe<Scalars['String']>;
    accountIdentifier?: Maybe<Scalars['ID']>;
    firstname?: Maybe<Scalars['String']>;
    lastname?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    info?: Maybe<Scalars['String']>;
    numberOfBedrooms?: Maybe<ZvtNumberOfBedrooms>;
    valuationType?: Maybe<ZvtValuationType>;
    whenToSell?: Maybe<ZvtWhenToSell>;
    isAdReachExpressLead?: Maybe<Scalars['Boolean']>;
};

export type ZvtFormSubmissionValuationResponse = {
    __typename?: 'ZVTFormSubmissionValuationResponse';
    ok: Scalars['Boolean'];
};

export type ZvtKeyValue = {
    __typename?: 'ZVTKeyValue';
    key: Scalars['String'];
    value?: Maybe<Scalars['Int']>;
};

export enum ZvtNumberOfBedrooms {
    One = 'ONE',
    Two = 'TWO',
    Three = 'THREE',
    Four = 'FOUR',
    Five = 'FIVE',
    SixPlus = 'SIX_PLUS'
}

export type ZvtValidateEmailInput = {
    email?: Maybe<Scalars['String']>;
};

export type ZvtValidateEmailResponse = {
    __typename?: 'ZVTValidateEmailResponse';
    valid?: Maybe<Scalars['Boolean']>;
};

export enum ZvtValuationType {
    SalesAndLettings = 'SALES_AND_LETTINGS',
    Sales = 'SALES',
    Lettings = 'LETTINGS'
}

export enum ZvtWhenToSell {
    Within_3Months = 'WITHIN_3_MONTHS',
    Within_6Months = 'WITHIN_6_MONTHS',
    Within_12Months = 'WITHIN_12_MONTHS',
    JustCurious = 'JUST_CURIOUS'
}

export type ZooplaValuationToolData = {
    __typename?: 'ZooplaValuationToolData';
    toolActive?: Maybe<Scalars['Boolean']>;
    customerKey: Scalars['ID'];
    agencyName?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    logoBaseUrl?: Maybe<Scalars['String']>;
    logoFileName?: Maybe<Scalars['String']>;
    numberOfBedrooms?: Maybe<Array<Maybe<ZvtKeyValue>>>;
    primaryColorHex?: Maybe<Scalars['String']>;
    secondaryColorHex?: Maybe<Scalars['String']>;
    valuationTypes?: Maybe<Array<Maybe<ZvtKeyValue>>>;
    whenToSell?: Maybe<Array<Maybe<ZvtKeyValue>>>;
};
